{
	"en": {
		"NOT_STARTED": "Surveys",
		"OPACITY": "Opacity",
		"DESIGN": "Designs",
		"GET_DATA": "Data acquisition",
		"Addtemporaryroad": "Add temporary road",
		"Addtemporarytrench": "Add temporary trench",
		"Addfoundationexcavation": "Add foundation excavation",
		"Roadparameter": "Road parameter",
		"Trenchparameter": "Trench parameter",
		"Cutsetting": "Cut setting",
		"Fillsetting": "Fill setting",
		"Soilvolume": "Soil volume",
		"SurfaceArea": "Surface area",
		"Longitudinalsectionview": "Longitudinal section view",
		"CROSS_SECTION": "cross section",
		"SWAP_XY": "Swap XY",
		"Crosssectionview": "Cross section view",
		"Measurementview": "Measurement view",
		"CREATE_DISTANCE_POINTS": "Create distance between two points",
		"Accountmanagement": "Account management",
		"Refresh": "Refresh",
		"EXPORT_AS": "Export as...",
		"FLY_TO_ANNOTATION": "Go to annotation",
		"EDIT": "Edit",
		"FINISH_EDITING": "Finish editing",
		"CANNOT_FINISH_EDITING_INVALID_VALUES": "Cannot finish editing due to invalid values",
		"CANNOT_SHOW_OBJECT_INVALID_VALUES": "Cannot display the object due to invalid values",
		"REMOVE": "Remove",
		"DUPLICATE": "Duplicate",
		"DUPLICATION_SUCCESSFUL": "Duplication successful",
		"DUPLICATION_FAILED": "Duplication failed",
		"DELETION_FAILED": "Deletion failed",
		"LandXML": "LandXML",
		"GEOTIFF": "Geotiff",
		"ExportRoad": "Export【{name}】.",
		"ExportObject": "Export {name}.",
		"SelectOutputFormat": "Please select export format.",
		"Registertodashboard": "Register to Smart Construction Dashboard",
		"OK": "OK",
		"CANCEL": "Cancel",
		"BACK": "Back",
		"Lengthofroad": "Length of road",
		"Lengthoftrench": "Length of trench",
		"Widthofroad": "Width of road",
		"Widthoftrench": "Width of trench",
		"Left": "Left",
		"Right": "Right",
		"Elevationarea": "Elevation area",
		"Gradientarea": "Gradient area",
		"Setsuperelevation": "Set super elevation",
		"Crossslope": "Cross Slope",
		"Superelevation": "Super Elevation",
		"Roadcrosssectiongradient": "Road cross section gradient",
		"Down": "+ -",
		"Up": "+ -",
		"ASSOCIATED_POINT_CLOUD": "Associated Point Cloud",
		"ASSOCIATED_TERRAIN_TYPE": "Associated Terrain Type",
		"ASSOCIATED_DESIGN_DATA": "Associated Design Data",
		"ASSOCIATED_REFERENCE_TOPOLOGY": "Associated Reference Topology",
		"Distance": "Distance",
		"SLOPE_COLOR": "Slope color",
		"ROAD_SURFACE_COLOR": "Road surface color",
		"COLOR_SETTINGS": "Color Settings",
		"CUT_SLOPE_COLOR": "Cut Slope Color",
		"FILL_SLOPE_COLOR": "Fill Slope Color",
		"TRENCH_SURFACE_COLOR": "Floor surface color",
		"Slopeheight": "Slope height",
		"Slopegradient": "Slope gradient",
		"LeftRightSettings": "Left/Right Settings",
		"BERM_SETTINGS": "Berm Settings",
		"Thereisberm": "Add berm",
		"Bermwidth": "Berm width",
		"Bermgradient": "Berm gradient",
		"Leftrightsetting": "Left right setting",
		"Leftcutsetting": "Left cut setting",
		"Rightcutsetting": "Right cut setting",
		"Cut": "Cut",
		"FILL": "Fill",
		"Roadname": "Road name",
		"Trenchname": "Trench name",
		"NAME": "Name",
		"ADD": "Add",
		"Apply": "Apply",
		"Linetype": "Line type",
		"Straightline": "Straight line",
		"Curvedline": "Curved line",
		"TangentAlignment": "Make everything straight",
		"SimpleCurveAlignment": "Make everything curved",
		"Control": "Control",
		"Undo": "Undo",
		"Redo": "Redo",
		"Finishdrawing": "Finish drawing",
		"Deletedrawing": "Delete drawing",
		"CONTROL_POINTS": "Control Points",
		"Remove": "Remove",
		"Extendroad": "Extend road",
		"MAX_LENGTH_ERROR": "Exceeding number of digits",
		"REQUIRED_ERROR": "Required fields",
		"Update": "Coordinate value",
		"UPDATE_DATA": "Data update",
		"ADD_DATA_LAYER": "Add data layer",
		"NO_DATA": "No data",
		"DATA_LAYERS": "Data layers",
		"PROJECT_SETTINGS": "Project settings",
		"DISTANCE_UNITS": "Distance units",
		"DISTANCE": "Distance",
		"AREA": "Area",
		"VOLUME": "Volume",
		"SLOPE": "Slope",
		"RATIO_WORD": "Ratio (:)",
		"METERS_SQUARED_UNIT": "m²",
		"SQUARE_METERS_WORD": "Square Meters (m²)",
		"METERS_WORD": "Meters (m)",
		"SQUARE_FEET_WORD": "Square Feet (sq ft)",
		"FEET_WORD": "Feet (ft)",
		"US_SURVEY_FEET_WORD": "US Survey Feet (ft)",
		"ACRES_WORD": "Acres (ac)",
		"HECTARES_WORD": "Hectares (ha)",
		"CUBIC_YARDS_WORD": "Cubic yards (cu yd)",
		"MEASUREMENT": "measurement",
		"METERS_CUBED_UNIT": "m³",
		"METERS_CUBED_WORD": "Cubic meters (m³)",
		"SELECT_DATA_TYPE": "Select data type",
		"UPLOAD": "Upload",
		"UPLOADING": "Uploading",
		"UPLOAD_ERROR": "Upload failed",
		"NoPointCloudSelected": "PointCloud is not Selected",
		"Roadctrlptwarning": "Invalid Control Point for Road",
		"INVALID_CONTROL_POINT_TRENCH": "Invalid Control Point for Trench",
		"ARBITRARY_LINE_CTRL_PT_WARNING": "Invalid Control Point for Line",
		"ASSET_NAME": "Layer name",
		"ASSET_CAPTURE_DATE": "Data capture date",
		"SELECT_SINGLE_DATASET_FILE": "Select File",
		"Projectlist": "Project list",
		"Project": "Project",
		"Addflatground": "Add flat ground",
		"Flatgroundname": "Flat ground name",
		"Leftfillsetting": "Left fill setting",
		"Rightfillsetting": "Right fill setting",
		"Alignwithterrain": "Align with terrain",
		"Alignwithstartpt.": "Align with start pt.",
		"SELECT_FILES": "Select files",
		"COORDINATE_SYSTEM": "Coordinate system",
		"CQW0020900001": "Coordinate system setting",
		"CQW0020900002": "Coordinate system selection",
		"CQW0020125006": "Apply the following coordinates",
		"CQW0020900004": "Coordinate system",
		"CQW0020900005": "vertical reference",
		"APPLY_LOCALIZATION_CHANGES": "apply localization",
		"CHANGE_COORDINATE_SYSTEM": "Change coordinate system",
		"CEW0020800001": "Failed to register coordinate system",
		"CQW0020800001": "Confirm the coordinate system. Is it OK?",
		"CIW0020800002": "*If the site is already registered in Smart Construction Dashboard, must be in the same coordinate system as Smart Construction Dashboard<br>*If data has already been uploaded to the site, please delete everything and re-upload.",
		"LOCALIZATION_FILE": "Import from Dashboard",
		"Confirm": "Confirm",
		"VERTICAL_DATUM": "Vertical datum",
		"POINT_CLOUD": "Surveys",
		"PROJECT": "Project",
		"JOBSITE_NAME": "Name",
		"OPEN": "Open",
		"ConfirmthecoordinatesystemAreyousure?": "Confirm the coordinate system Are you sure ?",
		"*Onceset,itcannotbechangedto": "* Once set, it cannot be changed to",
		"RoadadditionbyAI": "Road addition by AI",
		"RoadadditionTerrainByAI": "Road addition by AI Topographic information acquisition",
		"Updatecoordinatevalue": "Update Coordinate Value",
		"Surveysystem": "Survey system",
		"Switchdragmode": "Height change (points)",
		"globe": "Globe",
		"show": "Show",
		"hide": "Hide",
		"FLAT_GROUND_SURFACE_COLOR": "Top Surface Color",
		"failed": "failed",
		"successful": "successful",
		"axis": "Axis",
		"list_search_title": "Search Job Site",
		"sidebar_v_shift_title": "Vertical Shift",
		"number": "Number",
		"entity_upload_wait_msg": "File is currently uploading.\nPlease wait a few minutes and try again.",
		"RUBBLING_SETTINGS": "Rubbing Settings",
		"InterpolationPitch": "Distance",
		"RUBBLING_DESTINATION": "Rubbing Destination",
		"LABEL_DESIGN_FILE": "Design Filename",
		"LABEL_TERRAIN_FILE": "Terrain Filename",
		"LABEL_CONSTRUCTION_PARAM": "Construction lattice parameters",
		"LABEL_IMPORTANCE_COEFFICIENT": "importance coefficient",
		"LINEAR_DATA": "Line segment data between two points",
		"PRE_PROCESS": "Preprocess",
		"TEMPORARY_ROAD": "Temporary Road",
		"TEMPORARY_ROAD_AI": "Temporary Road",
		"TEMPORARY_TRENCH": "Temporary Trench",
		"TERRAIN_INFO": "terrain info",
		"TERRAIN_X_VALUE_MIN": "terrain X value min",
		"TERRAIN_X_VALUE_MAX": "terrain X value max",
		"TERRAIN_Y_VALUE_MIN": "terrain Y value min",
		"TERRAIN_Y_VALUE_MAX": "terrain Y value max",
		"DESIGN_X_VALUE_MIN": "design X value min",
		"DESIGN_X_VALUE_MAX": "design X value max",
		"DESIGN_Y_VALUE_MIN": "design Y value min",
		"DESIGN_Y_VALUE_MAX": "design Y value max",
		"TERRAIN_Z_VALUE_MIN": "terrain height min",
		"TERRAIN_Z_VALUE_MAX": "terrain height max",
		"DESIGN_Z_VALUE_MIN": "design height min",
		"DESIGN_Z_VALUE_MAX": "design height max",
		"INPUT_X_VALUE_MIN": "X value min",
		"INPUT_X_VALUE_MAX": "X value max",
		"INPUT_Y_VALUE_MIN": "Y value min",
		"INPUT_Y_VALUE_MAX": "Y value max",
		"INPUT_XY_INTERVAL": "XY interval",
		"INPUT_Z_VALUE_MIN": "Z value min",
		"INPUT_Z_VALUE_MAX": "Z value max",
		"INPUT_Z_INTERVAL": "Z interval",
		"INPUT_ALLOW_MAX_GRADIENT": "allow max gradient",
		"INPUT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PROMPT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PRIORITY_CUT": "Cut",
		"LABEL_PRIORITY_FILL": "Fill",
		"LABEL_PRIORITY_OVER_FILL": "Overfill",
		"LABEL_PRIORITY_OVER_CUT": "Overcut",
		"LABEL_PRIORITY_CF_DIFF": "Cut Fill Diff",
		"LABEL_PRIORITY_ROUTE": "Route Length",
		"MESSAGE_CONFIRM_START_END_POINT": "Create a temporary road at the two selected points.",
		"MESSAGE_CONFIRM_PREPROCESS": "Performs preprocessing of terrain information.",
		"MESSAGE_CONFIRM_SUFFIX": "Is it OK?",
		"MESSAGE_ERROR_PREPROCESS": "Failed to execute preprocessing.",
		"MESSAGE_ERROR_PREPROCESS_LOCKED": "Another user is performing pre-processing.",
		"MESSAGE_ERROR_CREATE_ROAD_AI": "Temporary road route search failed.",
		"MESSAGE_ERROR_INPUT_DATA_ERROR": "Input data error",
		"MESSAGE_ERROR_RANGE_START_END_POINT": "Include the coordinates of the starting and ending points.",
		"MESSAGE_ERROR_VALIDATE_REQUIRED": "Required.",
		"MESSAGE_ERROR_VALIDATE_COUNTER": "Max 20 characters.",
		"MESSAGE_ERROR_VALIDATE_NUMBER_LIMIT": "Please enter a value between 0.1 and 1.0.",
		"MESSAGE_ERROR_SELECT_START_END_POINT": "Specify the coordinate values including the design plane for the start and end points.",
		"SET_TERRAIN_DATA": "Set Terrain Data",
		"LABEL_COORDINATE_TEXT": "Coordinate",
		"TEXT_PROMPT_COORDINATE": "To specify a direct coordinate value,\n enter it directly in the box.",
		"LABEL_START_POINT": "Start Point",
		"LABEL_END_POINT": "End Point",
		"LABEL_X_COORDINATE": "X",
		"LABEL_Y_COORDINATE": "Y",
		"LABEL_Z_COORDINATE": "Z",
		"Startpoint": "Start point",
		"Endpoint": "End point",
		"Sectionheight": "Section height",
		"Designaltitude": "Design altitude",
		"COLOR": "color",
		"FLAT_GROUND": "Flat Ground",
		"FLATGROUND_PARAMETERS": "Flatground Parameters",
		"SegmentSetting": "Segment Setting",
		"FLATGROUND_INTERVAL": "Pitch length",
		"FLATGROUND_HEIGHT": "Max Height",
		"ERROR": "Error",
		"REFRESH_OBJECT_LIST": "Refreshing object list",
		"CANNOT_DELETE_ASSOCIATED_POINT_CLOUD": "Cannot be deleted because the specified object exists.",
		"EXCLUSIVE_EDIT": "While editing",
		"EXCLUSIVE_NOTICE": "{lockUser} is currently editing",
		"MULTIPLE_POINT_CLOUD_CANNOT_ADD": "If you are viewing multiple point clouds, you cannot add them",
		"ESRI_115700": "115700:WGS_1984(ellipsoid height)",
		"SELECT_COORDINATE_SYSTEM": "Select coordinate system (searchable)",
		"SELECT_VERTICAL_SHIFT": "Select geoid model (searchable)",
		"MEASUREMENT_SYSTEM": "Survey system",
		"ROAD_SAVE_FAILURE": "An error has occurred while creating the road. Please try again.",
		"FLAT_SAVE_FAILURE": "Flat field creation failed. Please create it again.",
		"TRENCH_SAVE_FAILURE": "An error has occurred while creating the trench. Please try again.",
		"LINEAR_SAVE_FAILURE": "An error has occurred while creating the linear. Please try again.",
		"With_Slope": "With Slope",
		"CREATE_LINEAR": "2-point measurement",
		"Uniformdrag": "Height change (plane)",
		"RENAME": "Change of Name",
		"Create Arc": "Create Arc",
		"EDITING_BY_OTHER_USER": "Editing by another user.",
		"LOCK_FAILED": "Failed to acquire lock.",
		"UPDATE_FAILED_SELF_EDITING": "Cannot update because there is an object being edited. \nPlease update again after finishing editing.",
		"UPDATE_FAILED_OTHER_USER_EDITING": "The object cannot be updated because another user is editing it.",
		"FAILED_TO_GET_EDITING_USER": "Failed to retrieve user information being edited.",
		"UPDATE_FAILED_EDITING_OR_UPLOADING": "Cannot update because there is data being edited or uploaded.",
		"Specified_Elevation": "Specified Elevation",
		"Longitudinal_Slope_Type": "Longitudinal Slope Type",
		"Longitudinal_Slope_Value": "Longitudinal Slope Value",
		"LS_DEFAULT": "Default",
		"LS_CONSTANT": "Constant",
		"LS_FLAT": "Flat",
		"LS_NONE": "Arbitrary setting from reference point height",
		"TRENCH_DEPTH": "Depth",
		"REFERENCE_POINT_CLOUD_ASSET": "Reference Point Cloud",
		"REFERENCE_DESIGN_ASSET": "Reference Design",
		"DEFAULT_ELEVATION": "Default Elevation",
		"OBJECT_DATA": "Object data",
		"SPECIFIED_ALTITUDE": "Specified Altitude",
		"SET_SPECIFIED_ALTITUDE": "Please set the altitude.",
		"BTN_OBJECT": "Add object",
		"SELECT_OBJECT": "Select object type",
		"PROJECTED_GROUND": "Clamp to surface",
		"REFERENCE_FLAT_GROUND": "Reference flat field",
		"LINEWORKS": "Lineworks",
		"ROAD": "Road",
		"FLATGROUND": "Flat ground",
		"TRENCH": "Trench",
		"Slope_Reference_Point": "reference point",
		"CREATE_LINEWORK": "Linework creation",
		"CREATE_LINEWORK_FROM_CENTER_LINE": "Linework creation",
		"LINEWORK_DATA": "LineWorks data",
		"ArbitraryLinename": "ArbitraryLine name",
		"WidthofLineWork": "Width of lineworks",
		"LineWorkparamater": "LineWork parameter",
		"ADD_LINEWORK_INFO": "Add Line work",
		"EDIT_LINEWORK_INFO": "Edit Line work",
		"SELECT_LINEWORKS_DATA": "Line works data selection",
		"REQUEST": "Request",
		"SELECT_DESIGN_DATA": "Design data selection",
		"SELECT_SURVEY_DATA": "Survey data selection",
		"STATION_INTERVAL": "Station Interval",
		"Linesectionview": "Line section view",
		"LINE_PROFILE_VIEW": "Line Profile View",
		"GENERATE_CROSS_SECTION": "Generate Cross-Section",
		"EDIT_CROSS_SECTION": "Edit Cross-Section",
		"ENABLE_VERTICAL_SLOPE_VALUE": "Vertical slope specification",
		"START_POINT": "Start point",
		"END_POINT": "End point",
		"LINEWORKS_LOADING_FAILED": "{name} loading failed",
		"LINEWORKS_CREATION_FAILED": "{name} creation failed",
		"LINEWORKS_DELETE_FAILED": "{name} delete failed",
		"LINEWORKS_EXPORT_FAILED": "{name} export failed",
		"LINEWORKS_CROSS_SECTION_DOWNLOAD_FAILED": "Cross-Section of {name} download failed",
		"LINEWORKS_UPDATE_FAILED": "Failed to update lineworks",
		"GEOTIFF_EXPORT_FAILED": "GeoTIFF export failed.",
		"EXPORT_CROSS_SECTION_DXF": "Export CrossSection",
		"EXPORT_CENTERLINE": "Export Centerline",
		"CENTER_LINE": "Centerline",
		"CENTER_LINE_CREATION_FAILED": "Failed to create the centerline for {name}.",
		"CROSS_SECTION_INVALID_VALUES": "Cannot display the cross section due to invalid values",
		"ADD_LINE_WORKS": "Add line works",
		"OUTPUT_DESTINATION": "Destination",
		"OUTPUT_FORMAT": "Format",
		"SAVE_TO_LOCAL": "Save to this PC",
		"DXF": "DXF",
		"SELECT_CREATION_TYPE": "Select creation type",
		"UPLOAD_LINE_WORKS": "Upload line works",
		"LICENSE_MIGRATION_MESSAGE": "License user registration is now mandatory. <br> You must assign user rights to licenses held by your company. The account you are currently logged in to is not registered. br> You can register as a license user from the link below. <br> [<a href={url}>Go to license usage registration</a>]<br> Only those with Super Admin or Admin (organization administrator) privileges can perform the registration operation. For all others, please ask your organization administrator to register. )",
		"NOTICE": "Notice",
		"LICENSE_CHECK": "License check",
		"NO_PERMISSION_TO_VIEW_SITE": "You do not have permission to view the site",
		"FAILED_TO_FETCH_SITE_INFO": "Failed to obtain site information",
		"NOT_EXIST_SITE_INFO": "Since the site does not exist, a new one has been created. \nWe apologize for the inconvenience, but please select the site again.",
		"ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP": "acquiring point cloud data from other app",
		"DROP_FILES_HERE": "Drop files here",
		"LOCALIZATION_FILE_UPLOAD_LABEL": "Localization file ({0})",
		"LOCALIZATION_FILE_UPLOAD_CAPTION": "Set the site location and site coordinate system",
		"INVALID_EXTENSION_ERROR": "The selected file has an incorrect extension",
		"FAILED_TO_CONVERT_LOCALIZATION_DATA": "Failed to convert to localization data",
		"UPLOAD_LOCALIZATION_FILE": "Upload file",
		"LINEWORKS_PROJECTION_SUCCESS": "Ground surface projection of {name} has been completed",
		"LINEWORKS_PROJECTION_FAILED": "Ground surface projection of {name} has failed",
		"LOCK_OR_UNLOCK_ERROR": "Failed to acquire or release lock",
		"LOST_OBJECT_EDIT_WEBSOCKET_CONNECTION": "The connection with the server has been lost. If you want to edit an object, please reload the page",
		"CONNECTION_LOST_LOCK_ERROR": "The connection to the server has been interrupted. Please reload the page to reconnect",
		"INVALID_SIMA_UPLOAD_FAILED": "Upload failed. {name} is an unsupported SIMA format file.",
		"DRAWING_2D_IMAGE": "Drawing 2D image",
		"SELECT_SITE_COORDINATE_SYSTEM_NOTE": "There is a difference in the registered coordinate system. Please select the coordinate system to use.",
		"SELECT_SITE_COORDINATE_SYSTEM_ALERT": "If you change the coordinate system from Design3D, objects you have created may no longer be usable.",
		"COORDINATE_SYSTEM_FROM": "Coordinate system({name})",
		"DESIGN_3D": "Design3D",
		"OTHER_APPLICATION": "other application",
		"LABEL_ROTATION": "rotation",
		"LABEL_ORIGIN_EASTING": "origin_easting",
		"LABEL_ORIGIN_NORTHING": "origin_northing",
		"LABEL_ORIGIN_LATITUDE": "origin_latitude",
		"LABEL_ORIGIN_LONGITUDE": "origin_longitude",
		"LABEL_SCALE_FACTOR": "scale_factor",
		"LABEL_VERTICAL_OFFSET": "vertical_shift",
		"LABEL_INCLINE_X": "incline_x",
		"LABEL_INCLINE_Y": "incline_y",
		"LABEL_TO_METERS": "toMeters",
		"LABEL_COORDINATE_SYSTEM": "COORDINATE_SYSTEM",
		"LABEL_VERTICAL_SHIFT": "VERTICAL_DATUM",
		"OPEN_THE_SITE": "open the site",
		"CHANGE_SITE_COORDINATE_SYSTEM_WARNING_MESSAGE": "The relative positions of the configured objects and the terrain may become misaligned, resulting in display and operation problems.",
		"PROCEED": "Proceed",
		"MESSAGE_ERROR_GET_COORDINATE_SYSTEM": "Failed to get coordinate system information.",
		"MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM": "Failed to set the coordinate system.",
		"MESSAGE_NOT_FOUND_LOCALIZATION_FILE": "Localization file not found. Please re-upload.",
		"MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE": "The site is not registered in Dashboard.",
		"MESSAGE_ERROR_DEFAULT": "An Unexpected Error has occurred.",
		"CLICK_TO_SELECT_SOURCE_POINT": "Click to select the {number} source point",
		"CLICK_TO_SELECT_DESTINATION_POINT": "Click to select the {number} destination point",
		"PLEASE_ENTER_VALID_INPUT": "Please enter valid input",
		"SOURCE_POINT": "Source",
		"DESTINATION_POINT": "Destination",
		"NO_DATA_AVAILABLE": "No data available",
		"TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE": "open the external page",
		"LABEL_DASHBOARD": "Dashboard",
		"LABEL_SIMULATION": "Simulation",
		"CLICK_ON_THE_MAP_TO_SET_IMAGE": "Click on the map to set the image",
		"REFERENCE_TOPOLOGY": "Reference Topology",
		"ELEVATION": "Elevation",
		"SAVE": "Save",
		"CREATE_REFERENCE_TOPOLOGY": "Create Reference Topology",
		"FILE_UPLOAD": "File upload",
		"IMPORT_FROM_GROUPWARE": "Import from Groupware",
		"UPLOAD_DATA_TYPE_LABEL": "Upload data type",
		"FILE_TYPE_NOT_SUPPORTED": "Unsupported file type",
		"NEXT": "Next",
		"FILE_NAME": "File Name",
		"IMAGE": "Image",
		"IMPORT_DATA_LAYER": "Import data layer",
		"SELECT_EXACTLY_TWO_TIFF_FILES": "Select exactly two TIFF files (one image and one terrain)",
		"FILE_AUTHOR": "File author",
		"LAST_MODIFIED": "Last modified",
		"LAST_MODIFIED_BY": "Last modified by",
		"FILE_SIZE": "File size",
		"HOME": "Home",
		"SEARCH_FILE_NAME": "Search file name",
		"SELECTED_FILES": "Selected files",
		"TIFF_PAIR_SELECTION_HINT": "TIFF files are added one at a time with Next. Once two are selected (one image and one terrain), the type selection opens.",
		"DTM_ORTHO_DATASET_FILE_COUNT_MISMATCH": "The folder does not contain exactly two TIFF files",
		"DTM_ORTHO_DATASET_SAME_ROLE": "Both TIFF files were identified as the same type",
		"AND_N_MORE": "and {number} more",
		"PREVIOUS": "Previous",
		"SELECT_A_SINGLE_FILE": "Select a single file",
		"LIST_DISPLAYING": "Displaying {from} - {to} of {total} item(s)",
		"SHOW_MORE": "Show more",
		"NO_MORE_PROJECTS": "There are no more projects to load.",
		"FAILED_TO_CREATE_REFERENCE_TOPOLOGY": "Failed to create reference topology",
		"TWO_POINT_ALIGNMENT": "2-point Alignment",
		"REGISTER_TO_GROUPWARE": "Register to Smart Construction Groupware",
		"ReferenceTopology": "Reference Topology",
		"PointCloud": "Point Cloud",
		"DesignData": "Design Data",
		"SELECT_ASSOCIATED_TERRAIN": "Please select associated terrain",
		"SELECT_RUBBING_DESTINATION": "Please select rubbing destination",
		"SIMPLE_STRUCTURE_DATA": "Simple Structure",
		"CUSTOM_STRUCTURE_DETAILS": "Custom Structure Details",
		"SHAPE_TYPE": "Shape type",
		"SHAPE_CUBE": "Cube",
		"SHAPE_SPHERE": "Sphere",
		"SHAPE_CYLINDER": "Cylinder",
		"TRANSPARENCY": "Transparency",
		"DIAMETER": "Diameter",
		"DIMENSION": "Dimension",
		"DIMENSIONS": "Dimensions",
		"RADIUS": "Radius",
		"ANCHOR_POINT": "Anchor point",
		"CENTER_POSITION": "Center position",
		"TRANSFORM": "Transform",
		"LOCAL_CENTER": "Local center",
		"ROTATION": "Rotation",
		"SCALE": "Scale",
		"RESET_TRANSFORM": "Reset transform",
		"CONFIRM_DELETE_SIMPLE_STRUCTURE_MESSAGE": "Are you sure you want to delete this Simple Structure?",
		"DELETE_SIMPLE_STRUCTURE": "Delete Simple Structure",
		"ADD_SIMPLE_STRUCTURE": "Add Simple Structure",
		"SIMPLE_STRUCTURE": "Simple Structure",
		"SELECT_STRUCTURE_TYPE": "Select Structure Type",
		"BASIC_INFO": "Basic Information",
		"PARAMETERS": "Parameters",
		"PLACEMENT_POSITION": "Placement Position",
		"POSITION": "Position",
		"STRUCTURE_TYPE_PIPE": "Pipe",
		"STRUCTURE_TYPE_BOX_CULVERT": "Box Culvert",
		"STRUCTURE_TYPE_RETAINING_WALL": "Retaining Wall",
		"STRUCTURE_TYPE_MANHOLE": "Manhole",
		"STRUCTURE_TYPE_MANUAL": "Custom",
		"ADD_PIPE": "Add Pipe",
		"ADD_BOX_CULVERT": "Add Box Culvert",
		"ADD_RETAINING_WALL": "Add Retaining Wall",
		"ADD_MANHOLE": "Add Manhole",
		"ADD_MANUAL": "Add Custom Structure",
		"ADD_CUBE": "Add Cube",
		"ADD_SPHERE": "Add Sphere",
		"ADD_CYLINDER": "Add Cylinder",
		"PIPE_DETAILS": "Pipe Details",
		"BOX_CULVERT_DETAILS": "Box Culvert Details",
		"RETAINING_WALL_DETAILS": "Retaining Wall Details",
		"MANHOLE_DETAILS": "Manhole Details",
		"PIPE_DIAMETER": "Diameter",
		"PIPE_BASIS_POINT_1": "Basis point 1",
		"PIPE_BASIS_POINT_2": "Basis point 2",
		"PIPE_LENGTH": "Length",
		"WALL_BASIS_POINT_1": "Basis point 1",
		"WALL_BASIS_POINT_2": "Basis point 2",
		"CULVERT_WIDTH": "Width",
		"CULVERT_HEIGHT": "Height",
		"CULVERT_LENGTH": "Length",
		"WALL_WIDTH": "Width",
		"WALL_HEIGHT": "Height",
		"WALL_LENGTH": "Length",
		"WALL_THICKNESS": "Thickness",
		"MANHOLE_SIZE_CUSTOM": "Custom",
		"MANHOLE_DIAMETER": "Diameter",
		"MANHOLE_DEPTH": "Depth",
		"MANUAL_LENGTH": "Length",
		"MANUAL_WIDTH": "Width",
		"MANUAL_HEIGHT": "Height",
		"GRADIENT": "Gradient",
		"GRADIENT_PERCENT": "Gradient (%)",
		"GRADIENT_RATIO": "Gradient (1:n)",
		"BASIS_POINT": "Basis point",
		"BASIS_POINT_1": "Basis point 1",
		"BASIS_POINT_2": "Basis point 2",
		"TWO_POINT_PICK_STEP1": "Click {point} (right-click to cancel)",
		"TWO_POINT_PICK_STEP2": "Click {point} (right-click to undo)",
		"COORDINATE_ACQUISITION_FAILED": "Failed to get coordinates",
		"AZIMUTH": "Azimuth",
		"SPREADING_COMPACTION": "Spreading / Compaction",
		"SPREADING_AND_COMPACTION": "Spreading and compaction",
		"SPREADING": "Spreading",
		"COMPACTION": "Compaction",
		"SETTINGS": "Settings",
		"COMPACTION_SURFACE_SPACING": "Compaction surface spacing",
		"SLOPE_SHOULDER_OFFSET": "Slope shoulder offset (inward)",
		"SLOPE_SHOULDER_OFFSET_TOOLTIP": "Distance from the slope shoulder toward the inside. Inward only; enter a positive value.",
		"REFERENCE_PLANE_SELECTION": "Reference plane selection",
		"FACES": "faces",
		"ANGLE_TOLERANCE": "Angle tolerance",
		"EXECUTE_SPREADING_COMPACTION": "Execute spreading / compaction",
		"LAYER_MODE": "Layer mode",
		"LAYER_MODE_PARALLEL": "Parallel to top surface",
		"LAYER_MODE_HORIZONTAL": "Horizontal",
		"LAYER_MODE_HORIZONTAL_TOOLTIP": "Creates a reference plane level with the ground, based on the highest point of the selected faces.",
		"COMPACTION_CSV_REQUIRES_REEXECUTION": "Compaction CSV is available after re-execution",
		"EXPORT": "Export",
		"SAVE_TO_GROUPWARE": "Save to Groupware",
		"SAVE_TO_GROUPWARE_SUCCESS": "Saved the spreading / compaction surfaces to Groupware",
		"SAVE_TO_GROUPWARE_FAILED": "Failed to save the spreading / compaction surfaces to Groupware",
		"TARGET": "Target",
		"TERRAIN": "Terrain",
		"SELECT_TARGET": "Select target",
		"SELECT_TERRAIN": "Select terrain",
		"Height": "Height",
		"Length": "Length",
		"Point": "Point",
		"Control Point": "Control Point",
		"Not Available": "Not Available",
		"X": "X",
		"Y": "Y",
		"Z": "Z",
		"Length On Datum": "Length On Datum",
		"name": "Name",
		"Enable": "Enable",
		"Disable": "Disable",
		"UpdateAlignment": "Update Alignment",
		"UpdateAlignmentDescription": "This alignment contains old curve data. How would you like to update alignment?",
		"VISIBILITY": "Visibility",
		"ALIGNMENT": "Alignment",
		"IP_LINE": "IP Line",
		"SURFACE": "Surface",
		"EMBANKMENT": "Embankment",
		"FILL_EMBANKMENT": "Fill Embankment",
		"CUT_EMBANKMENT": "Cut Embankment"
	},
	"ja": {
		"NOT_STARTED": "測量データ",
		"OPACITY": "透明度",
		"DESIGN": "設計データ",
		"GET_DATA": "データ取得",
		"Addtemporaryroad": "仮設道路追加",
		"Addtemporarytrench": "床掘",
		"Addfoundationexcavation": "根伐り",
		"Roadparameter": "道路",
		"Trenchparameter": "床掘",
		"Cutsetting": "切土設定",
		"Fillsetting": "盛土設定",
		"Soilvolume": "土量",
		"SurfaceArea": "表面積",
		"Longitudinalsectionview": "縦断ビュー",
		"CROSS_SECTION": "断面",
		"SWAP_XY": "XY入替",
		"Crosssectionview": "断面ビュー",
		"Measurementview": "任意断面ビュー",
		"CREATE_DISTANCE_POINTS": "2点間距離作成",
		"Accountmanagement": "アカウント管理",
		"Refresh": "最新の情報に更新",
		"EXPORT_AS": "出力",
		"FLY_TO_ANNOTATION": "移動",
		"EDIT": "編集",
		"FINISH_EDITING": "編集完了",
		"CANNOT_FINISH_EDITING_INVALID_VALUES": "無効な値のため編集を完了できません",
		"CANNOT_SHOW_OBJECT_INVALID_VALUES": "無効な値のためオブジェクトを表示できません",
		"REMOVE": "削除",
		"DUPLICATE": "複製",
		"DUPLICATION_SUCCESSFUL": "複製に成功しました",
		"DUPLICATION_FAILED": "複製に失敗しました",
		"DELETION_FAILED": "削除に失敗しました",
		"LandXML": "LandXML",
		"GEOTIFF": "Geotiff",
		"ExportRoad": "【{name}】を出力します。",
		"ExportObject": "【{name}】を出力します。",
		"SelectOutputFormat": "出力形式を選んでください。",
		"Registertodashboard": "Smart Construction Dashboardへ登録",
		"OK": "決定",
		"CANCEL": "キャンセル",
		"BACK": "戻る",
		"Lengthofroad": "道路長さ",
		"Lengthoftrench": "床掘長さ",
		"Widthofroad": "道路幅",
		"Widthoftrench": "床掘幅",
		"Left": "左",
		"Right": "右",
		"Elevationarea": "標高範囲",
		"Gradientarea": "勾配範囲",
		"Setsuperelevation": "片勾配にする",
		"Crossslope": "横断勾配",
		"Superelevation": "片勾配",
		"Roadcrosssectiongradient": "道路横断勾配",
		"Down": "下がり",
		"Up": "上がり",
		"ASSOCIATED_POINT_CLOUD": "摺り付け点群",
		"ASSOCIATED_TERRAIN_TYPE": "摺り付け地形タイプ",
		"ASSOCIATED_DESIGN_DATA": "摺り付け設計データ",
		"ASSOCIATED_REFERENCE_TOPOLOGY": "摺り付け基準トポロジ",
		"Distance": "摺り付けピッチ",
		"SLOPE_COLOR": "法面色",
		"ROAD_SURFACE_COLOR": "路面色",
		"COLOR_SETTINGS": "色設定",
		"CUT_SLOPE_COLOR": "切土法面色",
		"FILL_SLOPE_COLOR": "盛土法面色",
		"TRENCH_SURFACE_COLOR": "床面色",
		"Slopeheight": "法面高さ",
		"Slopegradient": "法面勾配",
		"LeftRightSettings": "左右設定",
		"BERM_SETTINGS": "小段設定",
		"Thereisberm": "小段あり",
		"Bermwidth": "小段幅",
		"Bermgradient": "小段勾配",
		"Leftrightsetting": "左右設定",
		"Leftcutsetting": "左切土設定",
		"Rightcutsetting": "右切土設定",
		"Cut": "切土",
		"FILL": "盛土",
		"Roadname": "道路名称",
		"Trenchname": "床掘名称",
		"NAME": "名称",
		"ADD": "追加",
		"Apply": "描画",
		"Linetype": "線の種類",
		"Straightline": "直線",
		"Curvedline": "曲線",
		"TangentAlignment": "全て直線にする",
		"SimpleCurveAlignment": "全て曲線にする",
		"Control": "操作",
		"Undo": "戻す(undo)",
		"Redo": "進む(redo)",
		"Finishdrawing": "描画の完了",
		"Deletedrawing": "描画の取り消し",
		"CONTROL_POINTS": "基準点",
		"Remove": "取り除く",
		"Extendroad": "道路の延長",
		"MAX_LENGTH_ERROR": "桁数が超過しています",
		"REQUIRED_ERROR": "必須項目です",
		"Update": "座標値",
		"UPDATE_DATA": "データ更新",
		"ADD_DATA_LAYER": "データレイヤー追加",
		"NO_DATA": "データがありません",
		"DATA_LAYERS": "データレイヤー",
		"PROJECT_SETTINGS": "各種設定",
		"DISTANCE_UNITS": "単位",
		"DISTANCE": "距離",
		"AREA": "面積",
		"VOLUME": "土量計測",
		"SLOPE": "勾配",
		"RATIO_WORD": "比率",
		"METERS_SQUARED_UNIT": "m²",
		"SQUARE_METERS_WORD": "平方メートル (m²)",
		"METERS_WORD": "メートル (m)",
		"SQUARE_FEET_WORD": "平方フィート (sq ft)",
		"FEET_WORD": "フィート (ft)",
		"US_SURVEY_FEET_WORD": "USフィート (ft)",
		"ACRES_WORD": "エーカー (ac)",
		"HECTARES_WORD": "ヘクタール (ha)",
		"CUBIC_YARDS_WORD": "立方ヤード (cu yd)",
		"MEASUREMENT": "計測",
		"METERS_CUBED_UNIT": "m³",
		"METERS_CUBED_WORD": "立方メートル (m³)",
		"SELECT_DATA_TYPE": "データタイプを選択",
		"UPLOAD": "アップロード",
		"UPLOADING": "アップロード中",
		"UPLOAD_ERROR": "アップロードに失敗しました",
		"Roadctrlptwarning": "道路のコントロール ポイントが無効です",
		"INVALID_CONTROL_POINT_TRENCH": "床掘のコントロールポイントが無効です",
		"NoPointCloudSelected": "PointCloud is not Selected",
		"ARBITRARY_LINE_CTRL_PT_WARNING": "ラインの制御点が無効です",
		"ASSET_NAME": "データ名",
		"ASSET_CAPTURE_DATE": "データ取得日",
		"SELECT_SINGLE_DATASET_FILE": "ファイルを選択",
		"Projectlist": "プロジェクトリスト画面",
		"Project": "プロジェクト画面",
		"Addflatground": "平場追加",
		"Flatgroundname": "平場名称",
		"Leftfillsetting": "左盛土設定",
		"Rightfillsetting": "右盛土設定",
		"Alignwithterrain": "地形に合わせる",
		"Alignwithstartpt.": "始点に合わせる",
		"SELECT_FILES": "ファイル選択",
		"COORDINATE_SYSTEM": "座標系",
		"CQW0020900001": "座標系設定",
		"CQW0020900002": "座標系選択",
		"CQW0020125006": "以下の座標系を適用します",
		"CQW0020900004": "座標系",
		"CQW0020900005": "垂直基準",
		"APPLY_LOCALIZATION_CHANGES": "ローカライゼーションを適用します",
		"CHANGE_COORDINATE_SYSTEM": "座標系変更",
		"CEW0020800001": "座標系の登録に失敗しました",
		"CQW0020800001": "座標系を確定します。よろしいですか？",
		"CIW0020800002": "※現場がすでにSmart Construction Dashboardに登録されている場合、Smart Construction Dashboardと同じ座標系である必要があります。<br>※現場にすでにデータをアップロードされている場合、一度全て削除してから再アップロードしてください。",
		"LOCALIZATION_FILE": "Dashboard からデータ取り込み",
		"Confirm": "確定",
		"VERTICAL_DATUM": "垂直基準",
		"POINT_CLOUD": "測量データ",
		"PROJECT": "プロジェクト",
		"JOBSITE_NAME": "現場名",
		"OPEN": "開く",
		"ConfirmthecoordinatesystemAreyousure?": "座標系を確認してよろしいですか ?",
		"*Onceset,itcannotbechangedto": "※一度設定するとに変更できません",
		"RoadadditionbyAI": "AI道路生成",
		"RoadadditionTerrainByAI": "AI道路生成 地形情報取得",
		"Updatecoordinatevalue": "座標値を更新",
		"Surveysystem": "測量系",
		"Switchdragmode": "高さ変更(点)",
		"globe": "背景地図",
		"show": "表示",
		"hide": "非表示",
		"FLAT_GROUND_SURFACE_COLOR": "天端色",
		"failed": "失敗しました。",
		"successful": "成功しました。",
		"axis": "軸",
		"list_search_title": "現場の検索",
		"sidebar_v_shift_title": "垂直移動",
		"number": "番号",
		"entity_upload_wait_msg": "データのアップロードに時間を要しております。\nしばらく時間をおいてから再度アクセスしていただきますようお願いいたします。",
		"RUBBLING_SETTINGS": "摺り付け設定",
		"InterpolationPitch": "ピッチ",
		"RUBBLING_DESTINATION": "摺り付け先",
		"LABEL_DESIGN_FILE": "設計データ選択",
		"LABEL_TERRAIN_FILE": "地形データ選択",
		"LABEL_CONSTRUCTION_PARAM": "施工データ 格子パラメータ入力",
		"LABEL_IMPORTANCE_COEFFICIENT": "重要度係数",
		"LINEAR_DATA": "2点間線分データ",
		"PRE_PROCESS": "前処理",
		"TEMPORARY_ROAD": "仮設道路",
		"TEMPORARY_ROAD_AI": "仮設道路設定",
		"TERRAIN_INFO": "地形情報",
		"TERRAIN_X_VALUE_MIN": "基準地形 X値 最小値",
		"TERRAIN_X_VALUE_MAX": "基準地形 X値 最大値",
		"TERRAIN_Y_VALUE_MIN": "基準地形 Y値 最小値",
		"TERRAIN_Y_VALUE_MAX": "基準値形 Y値 最大値",
		"DESIGN_X_VALUE_MIN": "比較地形 X値 最小値",
		"DESIGN_X_VALUE_MAX": "比較地形 X値 最大値",
		"DESIGN_Y_VALUE_MIN": "比較地形 Y値 最小値",
		"DESIGN_Y_VALUE_MAX": "比較地形 Y値 最大値",
		"TERRAIN_Z_VALUE_MIN": "基準高 最小値",
		"TERRAIN_Z_VALUE_MAX": "基準高 最大値",
		"DESIGN_Z_VALUE_MIN": "比較高 最小値",
		"DESIGN_Z_VALUE_MAX": "比較高 最大値",
		"INPUT_X_VALUE_MIN": "Xの最小値",
		"INPUT_X_VALUE_MAX": "Xの最大値",
		"INPUT_Y_VALUE_MIN": "Yの最小値",
		"INPUT_Y_VALUE_MAX": "Yの最大値",
		"INPUT_XY_INTERVAL": "XY平面格子間隔(m)",
		"INPUT_Z_VALUE_MIN": "底面Z値",
		"INPUT_Z_VALUE_MAX": "上面Z値",
		"INPUT_Z_INTERVAL": "Z軸格子間隔(m)",
		"INPUT_ALLOW_MAX_GRADIENT": "許容最大勾配(%)",
		"INPUT_SEARCH_EXPANSION_RADIUS": "探索展開半径(m)",
		"LABEL_PROMPT_SEARCH_EXPANSION_RADIUS": "探索展開半径",
		"LABEL_PRIORITY_CUT": "切土",
		"LABEL_PRIORITY_FILL": "盛土",
		"LABEL_PRIORITY_OVER_FILL": "オーバーフィル",
		"LABEL_PRIORITY_OVER_CUT": "オーバーカット",
		"LABEL_PRIORITY_CF_DIFF": "切盛差分",
		"LABEL_PRIORITY_ROUTE": "ルート長",
		"MESSAGE_CONFIRM_START_END_POINT": "選択した2点で仮設道路を作成します。",
		"MESSAGE_CONFIRM_PREPROCESS": "地形情報の前処理を実施します。",
		"MESSAGE_CONFIRM_SUFFIX": "よろしいですか？",
		"MESSAGE_ERROR_PREPROCESS": "前処理の実行に失敗しました。",
		"MESSAGE_ERROR_PREPROCESS_LOCKED": "他のユーザーが前処理を実行中です。",
		"MESSAGE_ERROR_CREATE_ROAD_AI": "仮設道路ルートの探索に失敗しました。",
		"MESSAGE_ERROR_INPUT_DATA_ERROR": "入力値エラー",
		"MESSAGE_ERROR_RANGE_START_END_POINT": "始点・終点の座標を含めてください。",
		"MESSAGE_ERROR_VALIDATE_REQUIRED": "必須項目です。",
		"MESSAGE_ERROR_VALIDATE_COUNTER": "入力文字数は20文字までです。",
		"MESSAGE_ERROR_VALIDATE_NUMBER_LIMIT": "0.1～1.0の間の数値を入力してください。",
		"MESSAGE_ERROR_SELECT_START_END_POINT": "始点・終点には設計面を含む座標値を指定してください。",
		"SET_TERRAIN_DATA": "地形指定",
		"LABEL_COORDINATE_TEXT": "座標",
		"TEXT_PROMPT_COORDINATE": "直接座標値を指定する場合は\n枠内に直接入力して下さい",
		"LABEL_START_POINT": "始点",
		"LABEL_END_POINT": "終点",
		"LABEL_X_COORDINATE": "X",
		"LABEL_Y_COORDINATE": "Y",
		"LABEL_Z_COORDINATE": "Z",
		"Startpoint": "始点",
		"Endpoint": "終点",
		"Sectionheight": "断面高度",
		"Designaltitude": "設計高度",
		"COLOR": "色",
		"FLAT_GROUND": "平場",
		"FLATGROUND_PARAMETERS": "平場",
		"SegmentSetting": "区間設定",
		"FLATGROUND_INTERVAL": "法面ピッチ",
		"FLATGROUND_HEIGHT": "面最高値",
		"ERROR": "エラー",
		"REFRESH_OBJECT_LIST": "オブジェクトリストの最新化",
		"CANNOT_DELETE_ASSOCIATED_POINT_CLOUD": "すり付き先に指定されているオブジェクトが存在しているため、削除できません",
		"EXCLUSIVE_EDIT": "編集中",
		"EXCLUSIVE_NOTICE": "{lockUser}が編集中です。",
		"MULTIPLE_POINT_CLOUD_CANNOT_ADD": "複数点群を表示している場合、追加できません",
		"ESRI_115700": "115700:WGS_1984(楕円体高)",
		"SELECT_COORDINATE_SYSTEM": "座標系を選択（検索可）",
		"SELECT_VERTICAL_SHIFT": "ジオイドモデルを選択（検索可）",
		"MEASUREMENT_SYSTEM": "測量系",
		"ROAD_SAVE_FAILURE": "道路作成が失敗しました。もう一度作成してください。",
		"FLAT_SAVE_FAILURE": "平場作成が失敗しました。もう一度作成してください。",
		"TRENCH_SAVE_FAILURE": "床掘作成が失敗しました。もう一度作成してください。",
		"LINEAR_SAVE_FAILURE": "線形作成が失敗しました。もう一度作成してください。",
		"With_Slope": "法面あり",
		"CREATE_LINEAR": "2点間計測",
		"Uniformdrag": "高さ変更(面)",
		"RENAME": "名称変更",
		"Create Arc": "同心円",
		"EDITING_BY_OTHER_USER": "他のユーザーが編集中です。",
		"LOCK_FAILED": "ロックの取得に失敗しました。",
		"UPDATE_FAILED_SELF_EDITING": "編集中のオブジェクトがあるため更新できません。\n編集を終了してから再度更新してください。",
		"UPDATE_FAILED_OTHER_USER_EDITING": "他のユーザーがオブジェクトを編集中のため更新できません。",
		"FAILED_TO_GET_EDITING_USER": "編集中のユーザー情報の取得に失敗しました。",
		"UPDATE_FAILED_EDITING_OR_UPLOADING": "編集中またはアップロード中のデータがあるため更新できません。",
		"Specified_Elevation": "始点の床掘\n下面標高",
		"Longitudinal_Slope_Type": "勾配タイプ",
		"Longitudinal_Slope_Value": "縦断勾配",
		"LS_DEFAULT": "点群上の始点～終点の勾配",
		"LS_CONSTANT": "勾配指定",
		"LS_FLAT": "フラット",
		"LS_NONE": "基準点高さからの任意設定",
		"TRENCH_DEPTH": "床掘深さ",
		"REFERENCE_POINT_CLOUD_ASSET": "参照点群データ",
		"REFERENCE_DESIGN_ASSET": "参照設計データ",
		"DEFAULT_ELEVATION": "始点の標高",
		"OBJECT_DATA": "オブジェクトデータ",
		"SPECIFIED_ALTITUDE": "高度指定",
		"SET_SPECIFIED_ALTITUDE": "高度を設定してください",
		"BTN_OBJECT": "オブジェクト追加",
		"SELECT_OBJECT": "オブジェクトタイプを選択",
		"PROJECTED_GROUND": "地表面に投影",
		"REFERENCE_FLAT_GROUND": "参照平場データ",
		"LINEWORKS": "ラインワークス",
		"ROAD": "道路",
		"FLATGROUND": "平場",
		"TRENCH": "床掘",
		"Slope_Reference_Point": "参照基準点",
		"CREATE_LINEWORK": "任意線形作成",
		"CREATE_LINEWORK_FROM_CENTER_LINE": "中心線形作成",
		"LINEWORK_DATA": "線形データ",
		"ArbitraryLinename": "任意線形名称",
		"WidthofLineWork": "線形幅",
		"LineWorkparamater": "線形設定値",
		"ADD_LINEWORK_INFO": "線形情報追加",
		"EDIT_LINEWORK_INFO": "ラインワークの編集",
		"SELECT_LINEWORKS_DATA": "ラインワークスデータ選択",
		"REQUEST": "リクエスト",
		"SELECT_DESIGN_DATA": "設計データ選択",
		"SELECT_SURVEY_DATA": "測量データ選択",
		"STATION_INTERVAL": "測点間隔",
		"Linesectionview": "線形断面ビュー",
		"GENERATE_CROSS_SECTION": "断面の生成",
		"EDIT_CROSS_SECTION": "断面の編集",
		"ENABLE_VERTICAL_SLOPE_VALUE": "縦断勾配指定",
		"START_POINT": "始点",
		"END_POINT": "終点",
		"LINEWORKS_LOADING_FAILED": "{name} ロードに失敗しました",
		"LINEWORKS_CREATION_FAILED": "{name} 作成に失敗しました",
		"LINEWORKS_DELETE_FAILED": "{name} 削除に失敗しました",
		"LINEWORKS_EXPORT_FAILED": "{name} の出力に失敗しました",
		"LINEWORKS_CROSS_SECTION_DOWNLOAD_FAILED": "{name} の断面図のダウンロードに失敗しました",
		"LINEWORKS_UPDATE_FAILED": "線形の更新に失敗しました",
		"GEOTIFF_EXPORT_FAILED": "GeoTIFFの出力に失敗しました。",
		"EXPORT_CROSS_SECTION_DXF": "断面図出力",
		"EXPORT_CENTERLINE": "中心線形出力",
		"CENTER_LINE": "中心線形",
		"CENTER_LINE_CREATION_FAILED": "{name} の中心線形の作成に失敗しました",
		"CROSS_SECTION_INVALID_VALUES": "無効な値のため断面を表示できません",
		"ADD_LINE_WORKS": "線形追加",
		"OUTPUT_DESTINATION": "出力先",
		"OUTPUT_FORMAT": "フォーマット",
		"SAVE_TO_LOCAL": "このPCに保存",
		"DXF": "DXF",
		"SELECT_CREATION_TYPE": "作成タイプを選択",
		"UPLOAD_LINE_WORKS": "線形データアップロード",
		"LINE_PROFILE_VIEW": "線形縦断ビュー",
		"LICENSE_MIGRATION_MESSAGE": "ライセンスの利用者登録が必須化されました。<br> 会社が保有しているライセンスに利用者の割り当てをしていただく必要があります。現在ログイン中のアカウントは、未登録となっています。<br> ライセンス利用者登録は、以下のリンクから可能です。<br> [<a href={url}>ライセンス利用登録へ</a>]<br> （権限がSuper Admin, Admin（組織管理者）の方のみが登録操作可能です。それ以外の方は、組織管理者に登録を依頼してください。）",
		"NOTICE": "お知らせ",
		"LICENSE_CHECK": "ライセンスチェック",
		"NO_PERMISSION_TO_VIEW_SITE": "現場の閲覧権限がありません",
		"FAILED_TO_FETCH_SITE_INFO": "現場情報の取得に失敗しました",
		"NOT_EXIST_SITE_INFO": "現場が存在しない為、新規作成しました。\nお手数ですが、再度現場を選択してください。",
		"ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP": "他アプリより点群データを取得中",
		"DROP_FILES_HERE": "Drop files here",
		"LOCALIZATION_FILE_UPLOAD_LABEL": "ローカライゼーションファイル ({0})",
		"LOCALIZATION_FILE_UPLOAD_CAPTION": "現場の位置と現場の座標系を設定します",
		"INVALID_EXTENSION_ERROR": "選択されたファイルの拡張子が正しくありません",
		"FAILED_TO_CONVERT_LOCALIZATION_DATA": "ローカライゼーションデータへの変換に失敗しました",
		"UPLOAD_LOCALIZATION_FILE": "ファイルをアップロードする",
		"LINEWORKS_PROJECTION_SUCCESS": "{name} の地表面投影が完了しました。",
		"LINEWORKS_PROJECTION_FAILED": "{name} の地表面投影に失敗しました。",
		"LOCK_OR_UNLOCK_ERROR": "ロックの取得または解放に失敗しました",
		"LOST_OBJECT_EDIT_WEBSOCKET_CONNECTION": "サーバーとの接続が途切れました。オブジェクトの編集を行う場合、ページの再読み込みを行ってください",
		"CONNECTION_LOST_LOCK_ERROR": "サーバーとの接続が途切れています。再接続のためページの再読み込みを行ってください",
		"INVALID_SIMA_UPLOAD_FAILED": "アップロードに失敗しました。{name} は未対応のSIMA形式ファイルです。",
		"DRAWING_2D_IMAGE": "二次元図面",
		"SELECT_SITE_COORDINATE_SYSTEM_NOTE": "登録された座標系に差分があります。使用する座標系を選択してください。",
		"SELECT_SITE_COORDINATE_SYSTEM_ALERT": "Design3Dの座標系から変更する場合、これまでに作成したオブジェクトが使用できなくなる可能性があります。",
		"COORDINATE_SYSTEM_FROM": "座標系({name})",
		"DESIGN_3D": "Design3D",
		"OTHER_APPLICATION": "他アプリ",
		"LABEL_ROTATION": "回転角(Rotation)",
		"LABEL_ORIGIN_EASTING": "東距原点(O.Easting)",
		"LABEL_ORIGIN_NORTHING": "北距原点(O.Northing)",
		"LABEL_ORIGIN_LATITUDE": "緯度原点(O.Latitude)",
		"LABEL_ORIGIN_LONGITUDE": "経度原点(O.Longitude)",
		"LABEL_SCALE_FACTOR": "縮尺係数(Scale factor)",
		"LABEL_VERTICAL_OFFSET": "垂直シフト(Vertical Shift)",
		"LABEL_INCLINE_X": "傾斜_x",
		"LABEL_INCLINE_Y": "傾斜_y",
		"LABEL_TO_METERS": "メートル変換",
		"LABEL_COORDINATE_SYSTEM": "座標系",
		"LABEL_VERTICAL_SHIFT": "垂直基準",
		"OPEN_THE_SITE": "現場を開く",
		"CHANGE_SITE_COORDINATE_SYSTEM_WARNING_MESSAGE": "設定済みオブジェクトと地形の位置関係がずれて表示や動作に不具合が生じる可能性があります。",
		"PROCEED": "進む",
		"MESSAGE_ERROR_GET_COORDINATE_SYSTEM": "座標系情報取得に失敗しました。",
		"MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM": "座標系の設定に失敗しました。",
		"MESSAGE_NOT_FOUND_LOCALIZATION_FILE": "ローカライゼーションファイルが見つかりませんでした。再度アップロードをお願い致します。",
		"MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE": "Dashboardに現場が登録されていません。",
		"MESSAGE_ERROR_DEFAULT": "予期せぬエラーが発生しました。",
		"CLICK_TO_SELECT_SOURCE_POINT": "地図をクリックして {number} 箇所目の移動前の点を選択します",
		"CLICK_TO_SELECT_DESTINATION_POINT": "地図をクリックして {number} 箇所目の移動後の点を選択します",
		"PLEASE_ENTER_VALID_INPUT": "有効な値を入力してください",
		"SOURCE_POINT": "移動前",
		"DESTINATION_POINT": "移動後",
		"NO_DATA_AVAILABLE": "利用可能なデータがありません",
		"TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE": "外部ページを開く",
		"LABEL_DASHBOARD": "Dashboard",
		"LABEL_SIMULATION": "Simulation",
		"CLICK_ON_THE_MAP_TO_SET_IMAGE": "地図をクリックして画像を設定します",
		"REFERENCE_TOPOLOGY": "基準平面",
		"ELEVATION": "標高",
		"SAVE": "保存",
		"CREATE_REFERENCE_TOPOLOGY": "基準平面作成",
		"FILE_UPLOAD": "ファイルアップロード",
		"IMPORT_FROM_GROUPWARE": "Groupware からインポート",
		"UPLOAD_DATA_TYPE_LABEL": "登録データの種類",
		"FILE_TYPE_NOT_SUPPORTED": "このファイル形式はサポート対象外です。",
		"NEXT": "次へ",
		"FILE_NAME": "ファイル名",
		"IMAGE": "画像",
		"IMPORT_DATA_LAYER": "データレイヤーの取り込み",
		"SELECT_EXACTLY_TWO_TIFF_FILES": "TIFFファイルを2つ（画像と地形）選択してください",
		"FILE_AUTHOR": "作成者",
		"LAST_MODIFIED": "最終更新",
		"LAST_MODIFIED_BY": "最終更新者",
		"FILE_SIZE": "サイズ",
		"HOME": "ホーム",
		"SEARCH_FILE_NAME": "ファイル名を検索",
		"SELECTED_FILES": "選択されたファイル",
		"TIFF_PAIR_SELECTION_HINT": "TIFFファイルは「次へ」で1件ずつ追加されます。2件（画像と地形）そろうと種別の選択に進みます。",
		"DTM_ORTHO_DATASET_FILE_COUNT_MISMATCH": "フォルダ内のTIFFファイルが2件ではありません",
		"DTM_ORTHO_DATASET_SAME_ROLE": "2件のTIFFファイルが同じ種別と判別されました",
		"AND_N_MORE": "残り {number}",
		"PREVIOUS": "前へ",
		"SELECT_A_SINGLE_FILE": "ファイルを一つだけ選択してください",
		"LIST_DISPLAYING": "全{total}件中{from}～{to}件を表示,",
		"SHOW_MORE": "さらに表示",
		"NO_MORE_PROJECTS": "読み込むプロジェクトがこれ以上ありません。",
		"FAILED_TO_CREATE_REFERENCE_TOPOLOGY": "基準平面の作成に失敗しました",
		"TWO_POINT_ALIGNMENT": "2点合わせ",
		"REGISTER_TO_GROUPWARE": "Smart Construction Groupwareへ登録",
		"ReferenceTopology": "基準平面",
		"PointCloud": "測量データ",
		"DesignData": "設計データ",
		"SELECT_ASSOCIATED_TERRAIN": "摺り付け地形を選択してください",
		"SELECT_RUBBING_DESTINATION": "摺り付け先を選択してください",
		"SIMPLE_STRUCTURE_DATA": "簡易構造物データ",
		"CUSTOM_STRUCTURE_DETAILS": "カスタム構造物詳細",
		"SHAPE_TYPE": "形状タイプ",
		"SHAPE_CUBE": "立方体",
		"SHAPE_SPHERE": "球体",
		"SHAPE_CYLINDER": "円柱",
		"TRANSPARENCY": "透明度",
		"DIAMETER": "直径",
		"DIMENSION": "寸法",
		"DIMENSIONS": "寸法",
		"RADIUS": "半径",
		"ANCHOR_POINT": "基準点",
		"CENTER_POSITION": "中心位置",
		"TRANSFORM": "変換",
		"LOCAL_CENTER": "ローカル中心",
		"ROTATION": "回転",
		"SCALE": "スケール",
		"RESET_TRANSFORM": "変換をリセット",
		"CONFIRM_DELETE_SOLID_MESH_MESSAGE": "このソリッドメッシュを削除してもよろしいですか？",
		"DELETE_SOLID_MESH": "ソリッドメッシュを削除",
		"CREATE_SOLID_MESH": "ソリッドメッシュを作成",
		"CONFIRM_DELETE_SIMPLE_STRUCTURE_MESSAGE": "この簡易構造物を削除してもよろしいですか？",
		"DELETE_SIMPLE_STRUCTURE": "簡易構造物を削除",
		"ADD_SIMPLE_STRUCTURE": "簡易構造物追加",
		"SIMPLE_STRUCTURE": "簡易構造物",
		"SELECT_STRUCTURE_TYPE": "構造物タイプを選択",
		"BASIC_INFO": "基本情報",
		"PARAMETERS": "パラメータ",
		"PLACEMENT_POSITION": "配置位置",
		"POSITION": "位置",
		"STRUCTURE_TYPE_PIPE": "配管",
		"STRUCTURE_TYPE_BOX_CULVERT": "ボックスカルバート",
		"STRUCTURE_TYPE_RETAINING_WALL": "擁壁",
		"STRUCTURE_TYPE_MANHOLE": "マンホール",
		"STRUCTURE_TYPE_MANUAL": "カスタム",
		"ADD_PIPE": "配管追加",
		"ADD_BOX_CULVERT": "ボックスカルバート追加",
		"ADD_RETAINING_WALL": "擁壁追加",
		"ADD_MANHOLE": "マンホール追加",
		"ADD_MANUAL": "カスタム構造物追加",
		"ADD_CUBE": "立方体追加",
		"ADD_SPHERE": "球体追加",
		"ADD_CYLINDER": "円柱追加",
		"PIPE_DETAILS": "配管詳細",
		"BOX_CULVERT_DETAILS": "ボックスカルバート詳細",
		"RETAINING_WALL_DETAILS": "擁壁詳細",
		"MANHOLE_DETAILS": "マンホール詳細",
		"PIPE_DIAMETER": "直径",
		"PIPE_BASIS_POINT_1": "基準点1",
		"PIPE_BASIS_POINT_2": "基準点2",
		"PIPE_LENGTH": "長さ",
		"WALL_BASIS_POINT_1": "基準点1",
		"WALL_BASIS_POINT_2": "基準点2",
		"CULVERT_WIDTH": "幅",
		"CULVERT_HEIGHT": "高さ",
		"CULVERT_LENGTH": "長さ",
		"WALL_WIDTH": "幅",
		"WALL_HEIGHT": "高さ",
		"WALL_LENGTH": "長さ",
		"WALL_THICKNESS": "厚さ",
		"MANHOLE_SIZE_CUSTOM": "カスタム",
		"MANHOLE_DIAMETER": "直径",
		"MANHOLE_DEPTH": "深さ",
		"MANUAL_LENGTH": "長さ",
		"MANUAL_WIDTH": "幅",
		"MANUAL_HEIGHT": "高さ",
		"GRADIENT": "勾配",
		"GRADIENT_PERCENT": "勾配（%）",
		"GRADIENT_RATIO": "勾配（1:n）",
		"BASIS_POINT": "基準点",
		"BASIS_POINT_1": "基準点1",
		"BASIS_POINT_2": "基準点2",
		"TWO_POINT_PICK_STEP1": "{point}をクリック（右クリックでキャンセル）",
		"TWO_POINT_PICK_STEP2": "{point}をクリック（右クリックでやり直し）",
		"COORDINATE_ACQUISITION_FAILED": "座標取得に失敗しました",
		"AZIMUTH": "方位角",
		"SPREADING_COMPACTION": "転圧巻きだし",
		"SPREADING_AND_COMPACTION": "転圧巻きだし",
		"SPREADING": "巻きだし",
		"COMPACTION": "転圧",
		"SETTINGS": "設定",
		"COMPACTION_SURFACE_SPACING": "転圧面間隔",
		"SLOPE_SHOULDER_OFFSET": "法面肩オフセット (内側)",
		"SLOPE_SHOULDER_OFFSET_TOOLTIP": "法肩から内側への距離。内側のみ。正の値で入力してください。",
		"REFERENCE_PLANE_SELECTION": "基準面選択",
		"FACES": "面",
		"ANGLE_TOLERANCE": "許容角度誤差",
		"EXECUTE_SPREADING_COMPACTION": "転圧巻きだし実施",
		"LAYER_MODE": "レイヤモード",
		"LAYER_MODE_PARALLEL": "天面平行",
		"LAYER_MODE_HORIZONTAL": "水平",
		"LAYER_MODE_HORIZONTAL_TOOLTIP": "選択した面の一番上の点を基準に、地面に水平な基準面を作成します。",
		"COMPACTION_CSV_REQUIRES_REEXECUTION": "転圧 CSV は再実行後に出力されます",
		"EXPORT": "エクスポート",
		"SAVE_TO_GROUPWARE": "Groupwareに保存",
		"SAVE_TO_GROUPWARE_SUCCESS": "巻き出し/転圧面をGroupwareに保存しました",
		"SAVE_TO_GROUPWARE_FAILED": "巻き出し/転圧面のGroupwareへの保存に失敗しました",
		"TARGET": "ターゲット",
		"TERRAIN": "地形",
		"SELECT_TARGET": "ターゲットを選択",
		"SELECT_TERRAIN": "地形を選択",
		"Height": "高さ",
		"Length": "路面距離",
		"Point": "点",
		"Control Point": "制御点",
		"Not Available": "情報なし",
		"X": "X",
		"Y": "Y",
		"Z": "Z",
		"Length On Datum": "水平距離",
		"name": "名前",
		"Enable": "高さ編集ON",
		"Disable": "高さ編集OFF",
		"UpdateAlignment": "整合性の更新",
		"UpdateAlignmentDescription": "この整合性には古い曲線データが含まれています。整合性をどのように更新しますか？",
		"VISIBILITY": "表示/非表示",
		"ALIGNMENT": "整合線",
		"IP_LINE": "IP線",
		"SURFACE": "路面",
		"EMBANKMENT": "堤防",
		"FILL_EMBANKMENT": "盛土",
		"CUT_EMBANKMENT": "切土"
	},
	"fr": {
		"NOT_STARTED": "Données de levé",
		"OPACITY": "Opacité",
		"DESIGN": "Conceptions",
		"GET_DATA": "L'acquisition des données",
		"Addtemporaryroad": "Ajouter une route temporaire",
		"Addtemporarytrench": "creuser un lit",
		"Addfoundationexcavation": "Excavation de fondation",
		"Roadparameter": "Paramètres de la route",
		"Trenchparameter": "Creusement/ponçage de sol",
		"Cutsetting": "Réglage déblais",
		"Fillsetting": "Réglage remblais",
		"Soilvolume": "Volume de terre",
		"SurfaceArea": "superficie",
		"Longitudinalsectionview": "Vue section longitudinale",
		"CROSS_SECTION": "coupe transversale",
		"SWAP_XY": "Permuter XY",
		"Crosssectionview": "Vue section transversale",
		"Measurementview": "Vue en coupe arbitraire",
		"CREATE_DISTANCE_POINTS": "Créer une distance entre deux points",
		"Accountmanagement": "Gestion compte",
		"Refresh": "rafraîchir",
		"EXPORT_AS": "Exporter comme…",
		"FLY_TO_ANNOTATION": "Aller à annotation",
		"EDIT": "Editer",
		"FINISH_EDITING": "Édition terminée",
		"CANNOT_FINISH_EDITING_INVALID_VALUES": "Impossible de terminer la modification en raison de valeurs incorrectes",
		"CANNOT_SHOW_OBJECT_INVALID_VALUES": "Impossible d'afficher l'objet en raison de valeurs incorrectes",
		"REMOVE": "Supprimer",
		"DUPLICATE": "",
		"DUPLICATION_SUCCESSFUL": "",
		"DUPLICATION_FAILED": "",
		"DELETION_FAILED": "",
		"LandXML": "LandXML",
		"GEOTIFF": "Geotiff",
		"ExportRoad": "Exporter【{name}】.",
		"ExportObject": "Exporter【{name}】.",
		"SelectOutputFormat": "Veuillez sélectionner un format d'exportation.",
		"Registertodashboard": "Enregistrer sur le tableau de bord Smart Construction",
		"OK": "D'ACCORD",
		"CANCEL": "Annuler",
		"BACK": "Retour",
		"Lengthofroad": "Longueur de la route",
		"Lengthoftrench": "Longueur d'excavation du lit",
		"Widthofroad": "Largeur de la route",
		"Widthoftrench": "Largeur d'excavation du lit",
		"Left": "Gauche",
		"Right": "Droite",
		"Elevationarea": "Zone hauteur",
		"Gradientarea": "Zone inclinaison",
		"Setsuperelevation": "Régler surélévation",
		"Crossslope": "Pente transversale",
		"Superelevation": "Super élévation",
		"Roadcrosssectiongradient": "Inclinaison transversale de la route",
		"Down": "+ -",
		"Up": "+ -",
		"ASSOCIATED_POINT_CLOUD": "Groupe de points glissants",
		"ASSOCIATED_TERRAIN_TYPE": "Type de terrain associé",
		"ASSOCIATED_DESIGN_DATA": "Données de conception associées",
		"ASSOCIATED_REFERENCE_TOPOLOGY": "Topologie de référence associée",
		"Distance": "Distance",
		"SLOPE_COLOR": "CCouleur de la pente",
		"ROAD_SURFACE_COLOR": "Couleur de la chaussée",
		"COLOR_SETTINGS": "Paramètres de couleur",
		"CUT_SLOPE_COLOR": "Couleur de pente de déblai",
		"FILL_SLOPE_COLOR": "Couleur de pente de remblai",
		"TRENCH_SURFACE_COLOR": "Couleur de la surface de la tranchée",
		"Slopeheight": "Hauteur de la pente",
		"Slopegradient": "Inclinaison de la pente",
		"LeftRightSettings": "Paramètres gauche/droite",
		"BERM_SETTINGS": "Paramètres de berme",
		"Thereisberm": "Ajouter une berme",
		"Bermwidth": "Largeur du talus",
		"Bermgradient": "Inclinaison du talus",
		"Leftrightsetting": "Réglage gauche droite",
		"Leftcutsetting": "Réglage déblais gauche",
		"Rightcutsetting": "Réglage déblais droite",
		"Cut": "Déblais",
		"FILL": "Remblais",
		"Roadname": "Nom de la route",
		"Trenchname": "Nom de l'excavation du sol",
		"NAME": "Nom",
		"ADD": "Ajouter",
		"Apply": "Appliquer",
		"Linetype": "Type de ligne",
		"Straightline": "Ligne droite",
		"Curvedline": "Ligne courbe",
		"TangentAlignment": "Mettre tout en ordre",
		"SimpleCurveAlignment": "Rendre tout courbé",
		"Control": "Contrôle",
		"Undo": "Défaire",
		"Redo": "Refaire",
		"Finishdrawing": "Terminer le dessin",
		"Deletedrawing": "Effacer le dessin",
		"CONTROL_POINTS": "Points de contrôle",
		"Remove": "Supprimer",
		"Extendroad": "Agrandir la route",
		"MAX_LENGTH_ERROR": "Nombre de chiffres dépassé",
		"REQUIRED_ERROR": "Champs obligatoires",
		"Update": "Valeur de coordonnée",
		"UPDATE_DATA": "Mise à jour des données",
		"ADD_DATA_LAYER": "Ajouter calques données",
		"NO_DATA": "Pas de donnée",
		"DATA_LAYERS": "Calques données",
		"PROJECT_SETTINGS": "Paramètres",
		"DISTANCE_UNITS": "Unités de distance",
		"DISTANCE": "Distance",
		"AREA": "Surface",
		"VOLUME": "Volume",
		"SLOPE": "Pente",
		"RATIO_WORD": "Proportion",
		"METERS_SQUARED_UNIT": "m²",
		"SQUARE_METERS_WORD": "Mètres carrés (m²)",
		"METERS_WORD": "Mètres (m)",
		"SQUARE_FEET_WORD": "Pieds carrés (sq ft)",
		"FEET_WORD": "Pieds (ft)",
		"US_SURVEY_FEET_WORD": "Pied US (ft)",
		"ACRES_WORD": "Acres (ac)",
		"HECTARES_WORD": "Hectares (ha)",
		"CUBIC_YARDS_WORD": "Yard cube (cu yd)",
		"MEASUREMENT": "la mesure",
		"METERS_CUBED_UNIT": "m³",
		"METERS_CUBED_WORD": "Mètres cubes (m³)",
		"SELECT_DATA_TYPE": "Sélectionner type de données",
		"UPLOAD": "Télécharger",
		"UPLOADING": "Téléchargement",
		"UPLOAD_ERROR": "Le téléchargement a échoué",
		"Roadctrlptwarning": "Point de contrôle non valide pour la route",
		"INVALID_CONTROL_POINT_TRENCH": "Point de contrôle non valide pour l'excavation du sol",
		"NoPointCloudSelected": "PointCloud is not Selected",
		"ARBITRARY_LINE_CTRL_PT_WARNING": "Point de contrôle non valide pour la ligne",
		"ASSET_NAME": "Nom ensemble de données",
		"ASSET_CAPTURE_DATE": "Date d'acquisition de l'ensemble de données",
		"SELECT_SINGLE_DATASET_FILE": "Sélectionner le fichier",
		"Projectlist": "Liste projet",
		"Project": "Projet",
		"Addflatground": "Ajouter terrain plat",
		"Flatgroundname": "Nom terrain plat",
		"Leftfillsetting": "Réglage remblais gauche",
		"Rightfillsetting": "Réglage remblais droite",
		"Alignwithterrain": "Aligner avec terrain",
		"Alignwithstartpt.": "Aligner avec pt départ",
		"SELECT_FILES": "Sélectionner des fichiers",
		"COORDINATE_SYSTEM": "Système de coordonée",
		"CQW0020900001": "Réglage du système de coordonnées",
		"CQW0020900002": "Sélection du système de coordonnées",
		"CQW0020125006": "Appliquer les coordonnées suivantes",
		"CQW0020900004": "Système de coordonnées",
		"CQW0020900005": "référence verticale",
		"APPLY_LOCALIZATION_CHANGES": "appliquer la localisation",
		"CHANGE_COORDINATE_SYSTEM": "Changement de coordonnées",
		"CEW0020800001": "Impossible d'enregistrer le système de coordonnées",
		"CQW0020800001": "Confirmez le système de coordonnées. Est-ce que c'est bon?",
		"CIW0020800002": "*Si le site est déjà enregistré dans Smart Construction Dashboard, doit être dans le même système de coordonnées que Smart Construction Dashboard.<br>*Si les données ont déjà été téléchargées sur le site, veuillez tout supprimer et ré-uploader.",
		"LOCALIZATION_FILE": "Importer depuis Dashboard",
		"Confirm": "Confirmer",
		"VERTICAL_DATUM": "Donnée verticale",
		"POINT_CLOUD": "Données de levé",
		"PROJECT": "Projet",
		"JOBSITE_NAME": "Nom du chantier",
		"OPEN": "Ouvrir",
		"ConfirmthecoordinatesystemAreyousure?": "Confirmer le système de coordonnées Êtes-vous sûr ?",
		"*Onceset,itcannotbechangedto": "* Une fois réglé, il ne peut pas être changé pour",
		"RoadadditionbyAI": "Ajout de route par IA",
		"RoadadditionTerrainByAI": "Mettre à jour la valeur des coordonnées",
		"Updatecoordinatevalue": "Système d'enquête",
		"Surveysystem": "Basculer en mode glisser",
		"Switchdragmode": "Changement de hauteur (points)",
		"globe": "Globe",
		"show": "Afficher",
		"hide": "Masquer",
		"FLAT_GROUND_SURFACE_COLOR": "Couleur de la surface supérieure",
		"failed": "Echec",
		"successful": "Effectué",
		"axis": "Axe",
		"list_search_title": "Rechercher chantier",
		"sidebar_v_shift_title": "Décalage vertical",
		"number": "Numéro",
		"entity_upload_wait_msg": "Il faut du temps pour télécharger les données.\nVeuillez réessayer d'accéder après avoir attendu un moment.",
		"RUBBLING_SETTINGS": "Paramètres d'interpolation",
		"InterpolationPitch": "Pas de glissement",
		"RUBBLING_DESTINATION": "destination du frottement",
		"LABEL_DESIGN_FILE": "Design Filename",
		"LABEL_TERRAIN_FILE": "Terrain Filename",
		"LABEL_CONSTRUCTION_PARAM": "Paramètres des grilles de construction",
		"LABEL_IMPORTANCE_COEFFICIENT": "importance coefficient",
		"LINEAR_DATA": "Données de segment de ligne entre deux points",
		"PRE_PROCESS": "Preprocess",
		"TEMPORARY_ROAD": "route temporaire",
		"TEMPORARY_ROAD_AI": "temporary_road_AI",
		"TERRAIN_INFO": "terrain info",
		"TERRAIN_X_VALUE_MIN": "terrain X value min",
		"TERRAIN_X_VALUE_MAX": "terrain X value max",
		"TERRAIN_Y_VALUE_MIN": "terrain Y value min",
		"TERRAIN_Y_VALUE_MAX": "terrain Y value max",
		"DESIGN_X_VALUE_MIN": "design X value min",
		"DESIGN_X_VALUE_MAX": "design X value max",
		"DESIGN_Y_VALUE_MIN": "design Y value min",
		"DESIGN_Y_VALUE_MAX": "design Y value max",
		"TERRAIN_Z_VALUE_MIN": "terrain height min",
		"TERRAIN_Z_VALUE_MAX": "terrain height max",
		"DESIGN_Z_VALUE_MIN": "design height min",
		"DESIGN_Z_VALUE_MAX": "design height max",
		"INPUT_X_VALUE_MIN": "X value min",
		"INPUT_X_VALUE_MAX": "X value max",
		"INPUT_Y_VALUE_MIN": "Y value min",
		"INPUT_Y_VALUE_MAX": "Y value max",
		"INPUT_XY_INTERVAL": "XY interval",
		"INPUT_Z_VALUE_MIN": "Z value min",
		"INPUT_Z_VALUE_MAX": "Z value max",
		"INPUT_Z_INTERVAL": "Z interval",
		"INPUT_ALLOW_MAX_GRADIENT": "allow max gradient",
		"INPUT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PROMPT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PRIORITY_CUT": "Cut",
		"LABEL_PRIORITY_FILL": "Fill",
		"LABEL_PRIORITY_OVER_FILL": "Overfill",
		"LABEL_PRIORITY_OVER_CUT": "Overcut",
		"LABEL_PRIORITY_CF_DIFF": "Cut Fill Diff",
		"LABEL_PRIORITY_ROUTE": "Route Length",
		"MESSAGE_CONFIRM_START_END_POINT": "Create a temporary road at the two selected points.",
		"MESSAGE_CONFIRM_PREPROCESS": "Performs preprocessing of terrain information.",
		"MESSAGE_CONFIRM_SUFFIX": "Is it OK?",
		"MESSAGE_ERROR_PREPROCESS": "Failed to execute preprocessing.",
		"MESSAGE_ERROR_PREPROCESS_LOCKED": "Another user is performing pre-processing.",
		"MESSAGE_ERROR_CREATE_ROAD_AI": "Temporary road route search failed.",
		"MESSAGE_ERROR_INPUT_DATA_ERROR": "Input data error",
		"MESSAGE_ERROR_RANGE_START_END_POINT": "Include the coordinates of the starting and ending points.",
		"MESSAGE_ERROR_VALIDATE_REQUIRED": "Required.",
		"MESSAGE_ERROR_VALIDATE_COUNTER": "Max 20 characters.",
		"MESSAGE_ERROR_VALIDATE_NUMBER_LIMIT": "Please enter a value between 0.1 and 1.0.",
		"MESSAGE_ERROR_SELECT_START_END_POINT": "Specify the coordinate values including the design plane for the start and end points.",
		"SET_TERRAIN_DATA": "Set Terrain Data",
		"LABEL_COORDINATE_TEXT": "Coordinate",
		"TEXT_PROMPT_COORDINATE": "To specify a direct coordinate value,\n enter it directly in the box.",
		"LABEL_START_POINT": "Start Point",
		"LABEL_END_POINT": "End Point",
		"LABEL_X_COORDINATE": "X",
		"LABEL_Y_COORDINATE": "Y",
		"LABEL_Z_COORDINATE": "Z",
		"Startpoint": "point de départ",
		"Endpoint": "le dernier arrêt",
		"Sectionheight": "Hauteur de section",
		"Designaltitude": "altitude de conception",
		"COLOR": "Couleur",
		"FLAT_GROUND": "champ plat",
		"FLATGROUND_PARAMETERS": "Paramètres du terrain plat",
		"SegmentSetting": "Réglage de section",
		"FLATGROUND_INTERVAL": "pas de pente",
		"FLATGROUND_HEIGHT": "Hauteur Maximale",
		"ERROR": "erreur",
		"REFRESH_OBJECT_LIST": "Actualisation de la liste d'objets",
		"CANNOT_DELETE_ASSOCIATED_POINT_CLOUD": "Ne peut pas être supprimé car l'objet spécifié existe.",
		"EXCLUSIVE_EDIT": "Pendant l'édition",
		"EXCLUSIVE_NOTICE": "{lockUser} est en cours d'édition",
		"MULTIPLE_POINT_CLOUD_CANNOT_ADD": "Si vous affichez plusieurs nuages de points, vous ne pouvez pas les ajouter",
		"ESRI_115700": "115700:WGS_1984(hauteur de l'ellipsoïde)",
		"SELECT_COORDINATE_SYSTEM": "Sélectionner le système de coordonnées (recherchable)",
		"SELECT_VERTICAL_SHIFT": "Sélectionner le modèle de géoïde (recherchable)",
		"MEASUREMENT_SYSTEM": "Système d'enquête",
		"ROAD_SAVE_FAILURE": "Une erreur s'est produite lors de la création de la route. Veuillez réessayer.",
		"FLAT_SAVE_FAILURE": "La création du champ simple a échoué. Veuillez le créer à nouveau.",
		"TRENCH_SAVE_FAILURE": "La création de l'excavation du sol a échoué. Veuillez le créer à nouveau.",
		"LINEAR_SAVE_FAILURE": "La création de l'linéaire du sol a échoué. Veuillez le créer à nouveau.",
		"With_Slope": "Avec Pente",
		"CREATE_LINEAR": "Mesure en 2 points",
		"Uniformdrag": "Changement de hauteur (surface)",
		"RENAME": "Changement de nom",
		"Create Arc": "cercles concentriques",
		"EDITING_BY_OTHER_USER": "Modification par un autre utilisateur.",
		"LOCK_FAILED": "Échec de l'acquisition du verrou.",
		"UPDATE_FAILED_SELF_EDITING": "Impossible de mettre à jour car un objet est en cours de modification. \nVeuillez mettre à jour à nouveau une fois les modifications terminées.",
		"UPDATE_FAILED_OTHER_USER_EDITING": "L'objet ne peut pas être mis à jour car un autre utilisateur est en train de le modifier.",
		"FAILED_TO_GET_EDITING_USER": "Échec de la récupération des informations utilisateur en cours de modification.",
		"UPDATE_FAILED_EDITING_OR_UPLOADING": "Impossible de mettre à jour car des données sont en cours de modification ou de téléchargement.",
		"Specified_Elevation": "Excavation du sol du point de départ\nÉlévation inférieure",
		"Longitudinal_Slope_Type": "Type de dégradé",
		"Longitudinal_Slope_Value": "Pente",
		"LS_DEFAULT": "Dégradé du point de départ au point final sur le nuage de points",
		"LS_CONSTANT": "Spécification du dégradé",
		"LS_FLAT": "plat",
		"LS_NONE": "Réglage arbitraire à partir de la hauteur du point de référence",
		"TRENCH_DEPTH": "profondeur d'excavation",
		"REFERENCE_POINT_CLOUD_ASSET": "Données de nuage de points de référence",
		"REFERENCE_DESIGN_ASSET": "Données de conception de référence",
		"DEFAULT_ELEVATION": "Altitude du point de départ",
		"OBJECT_DATA": "Données d'objet",
		"SPECIFIED_ALTITUDE": "Désignation de l'altitude",
		"SET_SPECIFIED_ALTITUDE": "Veuillez définir l'altitude",
		"BTN_OBJECT": "Ajouter un objet",
		"SELECT_OBJECT": "Sélectionnez le type d'objet",
		"PROJECTED_GROUND": "Projeté au sol",
		"REFERENCE_FLAT_GROUND": "Données plates de référence",
		"LINEWORKS": "dessins au trait",
		"ROAD": "route",
		"FLATGROUND": "champ plat",
		"TRENCH": "creuser un lit",
		"Slope_Reference_Point": "point de référence",
		"CREATE_LINEWORK": "Création linéaire arbitraire",
		"CREATE_LINEWORK_FROM_CENTER_LINE": "Création linéaire arbitraire",
		"LINEWORK_DATA": "données linéaires",
		"ArbitraryLinename": "Nom linéaire",
		"WidthofLineWork": "largeur linéaire",
		"LineWorkparamater": "Consigne linéaire",
		"ADD_LINEWORK_INFO": "Ajouter des informations linéaires",
		"EDIT_LINEWORK_INFO": "Modifier le travail en ligne",
		"SELECT_LINEWORKS_DATA": "Sélection des données des travaux en ligne",
		"REQUEST": "demande",
		"SELECT_DESIGN_DATA": "Sélection des données de conception",
		"SELECT_SURVEY_DATA": "Sélection des données de levé",
		"STATION_INTERVAL": "Intervalle des stations",
		"Linesectionview": "Vue en coupe linéaire",
		"GENERATE_CROSS_SECTION": "Générer une section",
		"EDIT_CROSS_SECTION": "Modifier la coupe",
		"ENABLE_VERTICAL_SLOPE_VALUE": "Spécification de la pente verticale",
		"START_POINT": "Point de départ",
		"END_POINT": "Point final",
		"LINEWORKS_LOADING_FAILED": "{name} échec du chargement",
		"LINEWORKS_CREATION_FAILED": "{name} la création a échoué",
		"LINEWORKS_DELETE_FAILED": "{name} échec de la suppression",
		"LINEWORKS_EXPORT_FAILED": "{name} échec de la sortie",
		"LINEWORKS_CROSS_SECTION_DOWNLOAD_FAILED": "Échec du téléchargement de la coupe transversale de {name}",
		"LINEWORKS_UPDATE_FAILED": "Échec de la mise à jour de la ligne",
		"GEOTIFF_EXPORT_FAILED": "L'exportation GeoTIFF a échoué.",
		"EXPORT_CROSS_SECTION_DXF": "Coupe transversale d'exportation",
		"EXPORT_CENTERLINE": "Exporter la ligne centrale",
		"CENTER_LINE": "Centre de ligne",
		"CENTER_LINE_CREATION_FAILED": "Échec de la création de la ligne centrale pour {name}.",
		"CROSS_SECTION_INVALID_VALUES": "Impossible de générer la section transversale en raison de valeurs incorrectes",
		"ADD_LINE_WORKS": "Ajouter une ligne",
		"OUTPUT_DESTINATION": "Destination",
		"OUTPUT_FORMAT": "Format",
		"SAVE_TO_LOCAL": "Enregistrer sur ce PC",
		"DXF": "DXF",
		"SELECT_CREATION_TYPE": "Sélectionnez le type de création",
		"UPLOAD_LINE_WORKS": "La ligne de téléchargement fonctionne",
		"LINE_PROFILE_VIEW": "Vue du profil de ligne",
		"LICENSE_MIGRATION_MESSAGE": "L'enregistrement des utilisateurs de licence est désormais obligatoire. <br> Vous devez attribuer des droits d'utilisateur aux licences détenues par votre entreprise. Le compte auquel vous êtes actuellement connecté n'est pas enregistré. br> Vous pouvez vous inscrire en tant qu'utilisateur de licence à partir du lien ci-dessous. <br> [<a href={url}>Accéder à l'enregistrement de l'utilisation de la licence</a>]<br> Seules les personnes disposant des privilèges de super-administrateur ou d'administrateur (administrateur de l'organisation) peuvent effectuer l'opération d'enregistrement. Pour tous les autres, veuillez demander à l’administrateur de votre organisation de vous inscrire. )",
		"NOTICE": "Avis",
		"LICENSE_CHECK": "Vérification de licence",
		"NO_PERMISSION_TO_VIEW_SITE": "Vous n'avez pas la permission de consulter le site",
		"FAILED_TO_FETCH_SITE_INFO": "Échec de l'obtention des informations sur le site",
		"NOT_EXIST_SITE_INFO": "",
		"ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP": "",
		"DROP_FILES_HERE": "Déposer les fichiers ici",
		"LOCALIZATION_FILE_UPLOAD_LABEL": "Fichier de localisation ({0})",
		"LOCALIZATION_FILE_UPLOAD_CAPTION": "Legen Sie den Standort und das Standortkoordinatensystem fest",
		"INVALID_EXTENSION_ERROR": "Le fichier sélectionné a une extension incorrecte",
		"FAILED_TO_CONVERT_LOCALIZATION_DATA": "Échec de la conversion en données de localisation",
		"UPLOAD_LOCALIZATION_FILE": "Téléverser un fichier",
		"LINEWORKS_PROJECTION_SUCCESS": "La projection de la surface du sol de {name} est terminée",
		"LINEWORKS_PROJECTION_FAILED": "La projection de la surface du sol de {name} a échoué",
		"LOCK_OR_UNLOCK_ERROR": "La connexion au serveur a été interrompue. Veuillez recharger la page pour vous reconnecter",
		"LOST_OBJECT_EDIT_WEBSOCKET_CONNECTION": "La connexion avec le serveur a été perdue. Si vous souhaitez modifier un objet, veuillez recharger la page",
		"CONNECTION_LOST_LOCK_ERROR": "La connexion au serveur a été interrompue. Veuillez recharger la page pour vous reconnecter",
		"INVALID_SIMA_UPLOAD_FAILED": "Le téléchargement a échoué. {name} est un fichier au format SIMA non pris en charge.",
		"DRAWING_2D_IMAGE": "Image 2D dessinée",
		"SELECT_SITE_COORDINATE_SYSTEM_NOTE": "Il y a une différence dans le système de coordonnées enregistré. Veuillez sélectionner le système de coordonnées à utiliser.",
		"SELECT_SITE_COORDINATE_SYSTEM_ALERT": "Si vous modifiez le système de coordonnées de Design3D, les objets que vous avez créés peuvent ne plus être utilisables.",
		"COORDINATE_SYSTEM_FROM": "Système de coordonnées({name})",
		"DESIGN_3D": "Design3D",
		"OTHER_APPLICATION": "autre application",
		"LABEL_ROTATION": "rotation",
		"LABEL_ORIGIN_EASTING": "origine_easting",
		"LABEL_ORIGIN_NORTHING": "origine_northing",
		"LABEL_ORIGIN_LATITUDE": "origine_latitude",
		"LABEL_ORIGIN_LONGITUDE": "origine_longitude",
		"LABEL_SCALE_FACTOR": "facteur d'échelle",
		"LABEL_VERTICAL_OFFSET": "décalage vertical",
		"LABEL_INCLINE_X": "inclinaison_x",
		"LABEL_INCLINE_Y": "inclinaison_y",
		"LABEL_TO_METERS": "conversion en mètres",
		"LABEL_COORDINATE_SYSTEM": "système de coordonnées",
		"LABEL_VERTICAL_SHIFT": "référence verticale",
		"OPEN_THE_SITE": "ouvrir le site",
		"CHANGE_SITE_COORDINATE_SYSTEM_WARNING_MESSAGE": "Les positions relatives des objets configurés et du terrain peuvent être mal alignées, ce qui entraîne des problèmes d'affichage et de fonctionnement.",
		"PROCEED": "Continuer",
		"MESSAGE_ERROR_GET_COORDINATE_SYSTEM": "Impossible d'obtenir les informations du système de coordonnées.",
		"MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM": "Impossible de définir le système de coordonnées.",
		"MESSAGE_NOT_FOUND_LOCALIZATION_FILE": "Fichier de localisation introuvable. Veuillez le télécharger à nouveau.",
		"MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE": "Le site n'est pas enregistré dans le Tableau de bord.",
		"MESSAGE_ERROR_DEFAULT": "Une erreur inattendue s'est produite.",
		"CLICK_TO_SELECT_SOURCE_POINT": "Cliquez sur la carte pour sélectionner le point source pour la position {number}",
		"CLICK_TO_SELECT_DESTINATION_POINT": "Cliquez sur la carte pour sélectionner le point de destination pour la position {number}",
		"PLEASE_ENTER_VALID_INPUT": "Veuillez entrer une entrée valide",
		"SOURCE_POINT": "Source",
		"DESTINATION_POINT": "Destination",
		"NO_DATA_AVAILABLE": "Aucune donnée disponible",
		"TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE": "ouvrir la page externe",
		"LABEL_DASHBOARD": "",
		"LABEL_SIMULATION": "",
		"CLICK_ON_THE_MAP_TO_SET_IMAGE": "",
		"REFERENCE_TOPOLOGY": "Topologie de référence",
		"ELEVATION": "Élévation",
		"SAVE": "Enregistrer",
		"CREATE_REFERENCE_TOPOLOGY": "Créer une topologie de référence",
		"FILE_UPLOAD": "Télécharger un fichier",
		"IMPORT_FROM_GROUPWARE": "Importer depuis Groupware",
		"UPLOAD_DATA_TYPE_LABEL": "Type de données à télécharger",
		"FILE_TYPE_NOT_SUPPORTED": "Type de fichier non supporté",
		"NEXT": "",
		"FILE_AUTHOR": "",
		"LAST_MODIFIED": "",
		"LAST_MODIFIED_BY": "",
		"FILE_SIZE": "",
		"HOME": "",
		"SEARCH_FILE_NAME": "",
		"AND_N_MORE": "",
		"LIST_DISPLAYING": "",
		"SHOW_MORE": "",
		"NO_MORE_PROJECTS": "",
		"FAILED_TO_CREATE_REFERENCE_TOPOLOGY": "Échec de la création de la topologie de référence",
		"TWO_POINT_ALIGNMENT": "Alignement à 2 points",
		"REGISTER_TO_GROUPWARE": "Enregistrer dans le Groupware Smart Construction",
		"ReferenceTopology": "Topologie de référence",
		"PointCloud": "Données de nuage de points",
		"DesignData": "Données de conception",
		"SELECT_ASSOCIATED_TERRAIN": "Veuillez sélectionner le terrain associé",
		"SELECT_RUBBING_DESTINATION": "Veuillez sélectionner la destination de friction",
		"SIMPLE_STRUCTURE_DATA": "Liste des structures simples",
		"CUSTOM_STRUCTURE_DETAILS": "Détails de la structure personnalisée",
		"SHAPE_TYPE": "Type de forme",
		"SHAPE_CUBE": "Cube",
		"SHAPE_SPHERE": "Sphère",
		"SHAPE_CYLINDER": "Cylindre",
		"TRANSPARENCY": "Transparence",
		"DIAMETER": "Diamètre",
		"DIMENSION": "Dimension",
		"DIMENSIONS": "Dimensions",
		"RADIUS": "Rayon",
		"ANCHOR_POINT": "Point d'ancrage",
		"CENTER_POSITION": "Position du centre",
		"TRANSFORM": "Transformation",
		"LOCAL_CENTER": "Centre local",
		"ROTATION": "Rotation",
		"SCALE": "Échelle",
		"RESET_TRANSFORM": "Réinitialiser la transformation",
		"CONFIRM_DELETE_SIMPLE_STRUCTURE_MESSAGE": "Voulez-vous supprimer cette structure simple ?",
		"DELETE_SIMPLE_STRUCTURE": "Supprimer la structure simple",
		"ADD_SIMPLE_STRUCTURE": "Ajouter une structure simple",
		"SIMPLE_STRUCTURE": "Structure simple",
		"SELECT_STRUCTURE_TYPE": "Sélectionner le type de structure",
		"BASIC_INFO": "Informations de base",
		"PARAMETERS": "Paramètres",
		"PLACEMENT_POSITION": "Position de placement",
		"POSITION": "Position",
		"STRUCTURE_TYPE_PIPE": "Tuyau",
		"STRUCTURE_TYPE_BOX_CULVERT": "Ponceau en boîte",
		"STRUCTURE_TYPE_RETAINING_WALL": "Mur de soutènement",
		"STRUCTURE_TYPE_MANHOLE": "Regard",
		"STRUCTURE_TYPE_MANUAL": "Personnalisé",
		"ADD_PIPE": "Ajouter tuyau",
		"ADD_BOX_CULVERT": "Ajouter ponceau en boîte",
		"ADD_RETAINING_WALL": "Ajouter mur de soutènement",
		"ADD_MANHOLE": "Ajouter regard",
		"ADD_MANUAL": "Ajouter structure personnalisée",
		"ADD_CUBE": "Ajouter Cube",
		"ADD_SPHERE": "Ajouter sphère",
		"ADD_CYLINDER": "Ajouter cylindre",
		"PIPE_DETAILS": "Détails du tuyau",
		"BOX_CULVERT_DETAILS": "Détails du ponceau en boîte",
		"RETAINING_WALL_DETAILS": "Détails du mur de soutènement",
		"MANHOLE_DETAILS": "Détails du regard",
		"PIPE_DIAMETER": "Diamètre",
		"PIPE_BASIS_POINT_1": "Point de base 1",
		"PIPE_BASIS_POINT_2": "Point de base 2",
		"PIPE_LENGTH": "Longueur",
		"WALL_BASIS_POINT_1": "Point de base 1",
		"WALL_BASIS_POINT_2": "Point de base 2",
		"CULVERT_WIDTH": "Largeur",
		"CULVERT_HEIGHT": "Hauteur",
		"CULVERT_LENGTH": "Longueur",
		"WALL_WIDTH": "Largeur",
		"WALL_HEIGHT": "Hauteur",
		"WALL_LENGTH": "Longueur",
		"WALL_THICKNESS": "Épaisseur",
		"MANHOLE_SIZE_CUSTOM": "Personnalisé",
		"MANHOLE_DIAMETER": "Diamètre",
		"MANHOLE_DEPTH": "Profondeur",
		"MANUAL_LENGTH": "Longueur",
		"MANUAL_WIDTH": "Largeur",
		"MANUAL_HEIGHT": "Hauteur",
		"GRADIENT": "Pente",
		"GRADIENT_PERCENT": "Pente (%)",
		"GRADIENT_RATIO": "Pente (1:n)",
		"BASIS_POINT": "Point de base",
		"BASIS_POINT_1": "Point de base 1",
		"BASIS_POINT_2": "Point de base 2",
		"TWO_POINT_PICK_STEP1": "Cliquer sur {point} (clic droit pour annuler)",
		"TWO_POINT_PICK_STEP2": "Cliquer sur {point} (clic droit pour annuler la sélection précédente)",
		"COORDINATE_ACQUISITION_FAILED": "Échec de l'obtention des coordonnées",
		"AZIMUTH": "Azimut",
		"Height": "Hauteur",
		"Length": "Longueur",
		"Point": "Point",
		"Control Point": "Point de contrôle",
		"Not Available": "Non disponible",
		"X": "X",
		"Y": "Y",
		"Z": "Z",
		"Length On Datum": "Longueur sur le sol",
		"name": "Nom",
		"Enable": "Activer",
		"Disable": "Désactiver",
		"UpdateAlignment": "Mise à jour de l'alignement",
		"UpdateAlignmentDescription": "Cet alignement contient d'anciennes données de courbe. Comment souhaitez-vous mettre à jour l'alignement ?",
		"VISIBILITY": "Affichage / Masquage",
		"ALIGNMENT": "Alignement",
		"IP_LINE": "IP Line",
		"SURFACE": "Surface",
		"EMBANKMENT": "Embankment",
		"FILL_EMBANKMENT": "Embankment",
		"CUT_EMBANKMENT": "Embankment"
	},
	"de": {
		"NOT_STARTED": "Vermessungsdaten",
		"OPACITY": "Transparenz",
		"DESIGN": "Entwürfe",
		"GET_DATA": "Datenerfassung",
		"Addtemporaryroad": "Temporäre Straße hinzufügen",
		"Addtemporarytrench": "Bett graben",
		"Addfoundationexcavation": "Fundamentaushub",
		"Roadparameter": "Straßenparameter",
		"Trenchparameter": "Boden graben/schleifen",
		"Cutsetting": "Abtrageinstellung",
		"Fillsetting": "Auftrageinstellung",
		"Soilvolume": "Bodenvolumen",
		"SurfaceArea": "Oberfläche",
		"Longitudinalsectionview": "Längsquerschnittsansicht",
		"CROSS_SECTION": "Querschnitt",
		"SWAP_XY": "XY tauschen",
		"Crosssectionview": "Querschnittsansicht",
		"Measurementview": "Beliebigeschnittansicht",
		"CREATE_DISTANCE_POINTS": "Abstand zwischen zwei Punkten erzeugen",
		"Accountmanagement": "Kontoverwaltung",
		"Refresh": "Aktualisierung",
		"EXPORT_AS": "Exportieren als...",
		"FLY_TO_ANNOTATION": "Gehe zu Anmerkung",
		"EDIT": "Editiere",
		"FINISH_EDITING": "Bearbeitung abgeschlossen",
		"CANNOT_FINISH_EDITING_INVALID_VALUES": "Kann die Bearbeitung aufgrund ungültiger Werte nicht abschließen",
		"CANNOT_SHOW_OBJECT_INVALID_VALUES": "Objekt kann aufgrund ungültiger Werte nicht angezeigt werden",
		"REMOVE": "Entfernen",
		"DUPLICATE": "",
		"DUPLICATION_SUCCESSFUL": "",
		"DUPLICATION_FAILED": "",
		"DELETION_FAILED": "",
		"LandXML": "LandXML",
		"GEOTIFF": "Geotiff",
		"ExportRoad": "【{name}】exportieren.",
		"ExportObject": "【{name}】exportieren.",
		"SelectOutputFormat": "Bitte Exportformat auswählen.",
		"Registertodashboard": "Im Smart Construction Dashboard registrieren",
		"OK": "OK",
		"CANCEL": "Abbrechen",
		"BACK": "Zurück",
		"Lengthofroad": "Straßenlänge",
		"Lengthoftrench": "Bettaushublänge",
		"Widthofroad": "Straßenbreite",
		"Widthoftrench": "Bettaushubbreite",
		"Left": "Links",
		"Right": "Rechts",
		"Elevationarea": "Höhengebiet",
		"Gradientarea": "Steigungsgebiet",
		"Setsuperelevation": "Überhöhung festlegen",
		"Crossslope": "Querneigung",
		"Superelevation": "Super Höhe",
		"Roadcrosssectiongradient": "Steigung des Straßenquerschnitts",
		"Down": "+ -",
		"Up": "+ -",
		"ASSOCIATED_POINT_CLOUD": "Gleitpunktgruppe",
		"ASSOCIATED_TERRAIN_TYPE": "Assoziiertes Geländetyp",
		"ASSOCIATED_DESIGN_DATA": "Assoziiertes Design-Daten",
		"ASSOCIATED_REFERENCE_TOPOLOGY": "Assoziiertes Referenz-Topologie",
		"Distance": "Abstand",
		"SLOPE_COLOR": "Böschungsfarbe",
		"ROAD_SURFACE_COLOR": "Fahrbahnfarbe",
		"COLOR_SETTINGS": "Farbeinstellungen",
		"CUT_SLOPE_COLOR": "Abtragböschungsfarbe",
		"FILL_SLOPE_COLOR": "Dammöschungsfarbe",
		"TRENCH_SURFACE_COLOR": "Grabenbodenfarbe",
		"Slopeheight": "Hanghöhe",
		"Slopegradient": "Hangsteigung",
		"LeftRightSettings": "Nastavení vlevo/vpravo",
		"BERM_SETTINGS": "Böschungsabsatz Einstellungen",
		"Thereisberm": "Bankett hinzufügen",
		"Bermwidth": "Böschungsabsatzbreite",
		"Bermgradient": "Böschungsabsatzsteigung",
		"Leftrightsetting": "Links-/Rechtseinstellung",
		"Leftcutsetting": "Linke Abtrageinstellung",
		"Rightcutsetting": "Rechte Abtrageinstellung",
		"Cut": "Abtrag",
		"FILL": "Einbau",
		"Roadname": "Straßenname",
		"Trenchname": "Name des Bodenaushubs",
		"NAME": "Name",
		"ADD": "Zufügen",
		"Apply": "Anwenden",
		"Linetype": "Linientyp",
		"Straightline": "Gerade Linie",
		"Curvedline": "Gekrümmte Linie",
		"TangentAlignment": "Mach alles klar",
		"SimpleCurveAlignment": "Machen Sie alles gebogen",
		"Control": "Steuerung",
		"Undo": "Rückgängig",
		"Redo": "Wiederherstellen",
		"Finishdrawing": "Zeichnung fertigstellen",
		"Deletedrawing": "Zeichnung löschen",
		"CONTROL_POINTS": "Kontrollpunkte",
		"Remove": "Entfernen",
		"Extendroad": "Straße verlängern",
		"MAX_LENGTH_ERROR": "Zu viele Ziffern",
		"REQUIRED_ERROR": "Benötigte Felder",
		"Update": "Koordinatenwert",
		"UPDATE_DATA": "Datenaktualisierung",
		"ADD_DATA_LAYER": "Ebene zufügen",
		"NO_DATA": "Keine Daten",
		"DATA_LAYERS": "Ebenen",
		"PROJECT_SETTINGS": "Einstellungen",
		"DISTANCE_UNITS": "Entfernungseinheiten",
		"DISTANCE": "Länge",
		"AREA": "Grundfläche",
		"VOLUME": "Volumen",
		"SLOPE": "Neigung",
		"RATIO_WORD": "Verhältnis",
		"METERS_SQUARED_UNIT": "m²",
		"SQUARE_METERS_WORD": "Quadratmeter (m²)",
		"METERS_WORD": "Meter (m)",
		"SQUARE_FEET_WORD": "Quadratfuß (sq ft)",
		"FEET_WORD": "Fuß (ft)",
		"US_SURVEY_FEET_WORD": "US Survey Feet (ft)",
		"ACRES_WORD": "Acres (ac)",
		"HECTARES_WORD": "Hektar (ha)",
		"CUBIC_YARDS_WORD": "Kubikyard (cu yd)",
		"MEASUREMENT": "Messung",
		"METERS_CUBED_UNIT": "m³",
		"METERS_CUBED_WORD": "Kubikmeter (m³)",
		"SELECT_DATA_TYPE": "Wähle Datentyp",
		"UPLOAD": "Hochladen",
		"UPLOADING": "Hochladen",
		"UPLOAD_ERROR": "Upload fehlgeschlagen",
		"Roadctrlptwarning": "Ungültiger Kontrollpunkt für Straße",
		"INVALID_CONTROL_POINT_TRENCH": "Ungültiger Kontrollpunkt für Bodenaushub",
		"NoPointCloudSelected": "PointCloud is not Selected",
		"ARBITRARY_LINE_CTRL_PT_WARNING": "Ungültiger Kontrollpunkt für Linie",
		"ASSET_NAME": "Datensatzname",
		"ASSET_CAPTURE_DATE": "Erfassungsdatum des Datensatzes",
		"SELECT_SINGLE_DATASET_FILE": "Wähle Datei",
		"Projectlist": "Projektliste",
		"Project": "Projekt",
		"Addflatground": "Ebenen Untergrund hinzufügen",
		"Flatgroundname": "Name des ebenen Untergrunds",
		"Leftfillsetting": "Linke Auftragseinstellung",
		"Rightfillsetting": "Rechte Auftragseinstellung",
		"Alignwithterrain": "Zu Gelände ausrichten",
		"Alignwithstartpt.": "Zu Startpkt. ausrichten",
		"SELECT_FILES": "Dateien auswählen",
		"COORDINATE_SYSTEM": "Koordinatensystem",
		"CQW0020900001": "Koordinatensystemeinstellung",
		"CQW0020900002": "Auswahl des Koordinatensystems",
		"CQW0020125006": "Wenden Sie die folgenden Koordinaten an",
		"CQW0020900004": "Koordinatensystem",
		"CQW0020900005": "vertikale Referenz",
		"APPLY_LOCALIZATION_CHANGES": "Lokalisierung anwenden",
		"CHANGE_COORDINATE_SYSTEM": "Koordinatenwechsel",
		"CEW0020800001": "Koordinatensystem konnte nicht registriert werden",
		"CQW0020800001": "Bestätigen Sie das Koordinatensystem. Ist es o.k?",
		"CIW0020800002": "*Falls die Seite bereits in Smart Construction Dashboard registriert ist, muss sich im selben Koordinatensystem wie Smart Construction Dashboard befinden.<br>*Wenn bereits Daten auf die Website hochgeladen wurden, bitte alles löschen und erneut hochladen.",
		"LOCALIZATION_FILE": "Importieren aus Dashboard",
		"Confirm": "Bestätigen",
		"VERTICAL_DATUM": "Höhendatum",
		"POINT_CLOUD": "Vermessungsdaten",
		"PROJECT": "Projekt",
		"JOBSITE_NAME": "Name der Baustelle",
		"OPEN": "Öffnen",
		"ConfirmthecoordinatesystemAreyousure?": "Koordinatensystem bestätigen Sind Sie sicher ?",
		"*Onceset,itcannotbechangedto": "* Einmal eingestellt, kann es nicht mehr geändert werden",
		"RoadadditionbyAI": "Straßenzusatz durch KI",
		"RoadadditionTerrainByAI": "Koordinatenwert aktualisieren",
		"Updatecoordinatevalue": "Umfragesystem",
		"Surveysystem": "Drag-Modus wechseln",
		"Switchdragmode": "Höhenänderung (Punkte)",
		"globe": "Globus",
		"show": "Zeigen",
		"hide": "Ausblenden",
		"FLAT_GROUND_SURFACE_COLOR": "Oberflächenfarbe",
		"failed": "fehlgeschlagen",
		"successful": "erfolgreich",
		"axis": "Achse",
		"list_search_title": "Baustelle suchen",
		"sidebar_v_shift_title": "Vertikaler Versatz",
		"number": "Nummer",
		"entity_upload_wait_msg": "Das Hochladen der Daten dauert.\nBitte versuchen Sie nach einer Weile erneut, darauf zuzugreifen.",
		"RUBBLING_SETTINGS": "Interpolationseinstellungen",
		"InterpolationPitch": "Gleittonhöhe",
		"RUBBLING_DESTINATION": "Reibziel",
		"LABEL_DESIGN_FILE": "Design Filename",
		"LABEL_TERRAIN_FILE": "Terrain Filename",
		"LABEL_CONSTRUCTION_PARAM": "Parameter des Konstruktionsgitters",
		"LABEL_IMPORTANCE_COEFFICIENT": "importance coefficient",
		"LINEAR_DATA": "Liniensegmentdaten zwischen zwei Punkten",
		"PRE_PROCESS": "Preprocess",
		"TEMPORARY_ROAD": "provisorische Straße",
		"TEMPORARY_ROAD_AI": "temporary_road_AI",
		"TERRAIN_INFO": "terrain info",
		"TERRAIN_X_VALUE_MIN": "terrain X value min",
		"TERRAIN_X_VALUE_MAX": "terrain X value max",
		"TERRAIN_Y_VALUE_MIN": "terrain Y value min",
		"TERRAIN_Y_VALUE_MAX": "terrain Y value max",
		"DESIGN_X_VALUE_MIN": "design X value min",
		"DESIGN_X_VALUE_MAX": "design X value max",
		"DESIGN_Y_VALUE_MIN": "design Y value min",
		"DESIGN_Y_VALUE_MAX": "design Y value max",
		"TERRAIN_Z_VALUE_MIN": "terrain height min",
		"TERRAIN_Z_VALUE_MAX": "terrain height max",
		"DESIGN_Z_VALUE_MIN": "design height min",
		"DESIGN_Z_VALUE_MAX": "design height max",
		"INPUT_X_VALUE_MIN": "X value min",
		"INPUT_X_VALUE_MAX": "X value max",
		"INPUT_Y_VALUE_MIN": "Y value min",
		"INPUT_Y_VALUE_MAX": "Y value max",
		"INPUT_XY_INTERVAL": "XY interval",
		"INPUT_Z_VALUE_MIN": "Z value min",
		"INPUT_Z_VALUE_MAX": "Z value max",
		"INPUT_Z_INTERVAL": "Z interval",
		"INPUT_ALLOW_MAX_GRADIENT": "allow max gradient",
		"INPUT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PROMPT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PRIORITY_CUT": "Cut",
		"LABEL_PRIORITY_FILL": "Fill",
		"LABEL_PRIORITY_OVER_FILL": "Overfill",
		"LABEL_PRIORITY_OVER_CUT": "Overcut",
		"LABEL_PRIORITY_CF_DIFF": "Cut Fill Diff",
		"LABEL_PRIORITY_ROUTE": "Route Length",
		"MESSAGE_CONFIRM_START_END_POINT": "Create a temporary road at the two selected points.",
		"MESSAGE_CONFIRM_PREPROCESS": "Performs preprocessing of terrain information.",
		"MESSAGE_CONFIRM_SUFFIX": "Is it OK?",
		"MESSAGE_ERROR_PREPROCESS": "Failed to execute preprocessing.",
		"MESSAGE_ERROR_PREPROCESS_LOCKED": "Another user is performing pre-processing.",
		"MESSAGE_ERROR_CREATE_ROAD_AI": "Temporary road route search failed.",
		"MESSAGE_ERROR_INPUT_DATA_ERROR": "Input data error",
		"MESSAGE_ERROR_RANGE_START_END_POINT": "Include the coordinates of the starting and ending points.",
		"MESSAGE_ERROR_VALIDATE_REQUIRED": "Required.",
		"MESSAGE_ERROR_VALIDATE_COUNTER": "Max 20 characters.",
		"MESSAGE_ERROR_VALIDATE_NUMBER_LIMIT": "Please enter a value between 0.1 and 1.0.",
		"MESSAGE_ERROR_SELECT_START_END_POINT": "Specify the coordinate values including the design plane for the start and end points.",
		"SET_TERRAIN_DATA": "Set Terrain Data",
		"LABEL_COORDINATE_TEXT": "Coordinate",
		"TEXT_PROMPT_COORDINATE": "To specify a direct coordinate value,\n enter it directly in the box.",
		"LABEL_START_POINT": "Start Point",
		"LABEL_END_POINT": "End Point",
		"LABEL_X_COORDINATE": "X",
		"LABEL_Y_COORDINATE": "Y",
		"LABEL_Z_COORDINATE": "Z",
		"Startpoint": "Startpunkt",
		"Endpoint": "die letzte Station",
		"Sectionheight": "Schnitthöhe",
		"Designaltitude": "Entwurfshöhe",
		"COLOR": "Farbe",
		"FLAT_GROUND": "flaches Feld",
		"FLATGROUND_PARAMETERS": "flache Bodenparameter",
		"SegmentSetting": "Abschnittseinstellung",
		"FLATGROUND_INTERVAL": "Neigungswinkel",
		"FLATGROUND_HEIGHT": "Maximale Höhe",
		"ERROR": "Fehler",
		"REFRESH_OBJECT_LIST": "Aktualisierte Objektliste",
		"CANNOT_DELETE_ASSOCIATED_POINT_CLOUD": "Kann nicht gelöscht werden, da das angegebene Objekt vorhanden ist.",
		"EXCLUSIVE_EDIT": "Während der Bearbeitung",
		"EXCLUSIVE_NOTICE": "{lockUser} wird gerade bearbeitet",
		"MULTIPLE_POINT_CLOUD_CANNOT_ADD": "Wenn Sie mehrere Punktwolken anzeigen, können Sie diese nicht hinzufügen.",
		"ESRI_115700": "115700:WGS_1984(Ellipsoidhöhe)",
		"SELECT_COORDINATE_SYSTEM": "Koordinatensystem auswählen (durchsuchbar)",
		"SELECT_VERTICAL_SHIFT": "Geoidmodell auswählen (durchsuchbar)",
		"MEASUREMENT_SYSTEM": "Umfragesystem",
		"ROAD_SAVE_FAILURE": "Beim Erstellen der Straße ist ein Fehler aufgetreten. Bitte versuche es erneut.",
		"FLAT_SAVE_FAILURE": "Die Erstellung des einfachen Felds ist fehlgeschlagen. Bitte erstellen Sie es erneut.",
		"TRENCH_SAVE_FAILURE": "Die Erstellung des Bodenaushubs ist fehlgeschlagen. Bitte erstellen Sie es erneut.",
		"LINEAR_SAVE_FAILURE": "Die Erstellung des linear ist fehlgeschlagen. Bitte erstellen Sie es erneut.",
		"With_Slope": "Mit Gradient",
		"CREATE_LINEAR": "2-Punkt-Messung",
		"Uniformdrag": "Höhenänderung (Ebene)",
		"RENAME": "Namensänderung",
		"Create Arc": "konzentrische Kreise",
		"EDITING_BY_OTHER_USER": "Bearbeitung durch einen anderen Benutzer.",
		"LOCK_FAILED": "Die Sperre konnte nicht erworben werden.",
		"UPDATE_FAILED_SELF_EDITING": "Aktualisierung nicht möglich, da ein Objekt bearbeitet wird. \nBitte aktualisieren Sie erneut, nachdem Sie die Bearbeitung abgeschlossen haben.",
		"UPDATE_FAILED_OTHER_USER_EDITING": "Das Objekt kann nicht aktualisiert werden, da es von einem anderen Benutzer bearbeitet wird.",
		"FAILED_TO_GET_EDITING_USER": "Die bearbeiteten Benutzerinformationen konnten nicht abgerufen werden.",
		"UPDATE_FAILED_EDITING_OR_UPLOADING": "Aktualisierung nicht möglich, da Daten bearbeitet oder hochgeladen werden.",
		"Specified_Elevation": "Ausgangspunkt Bodenaushub\nBodenhöhe",
		"Longitudinal_Slope_Type": "Farbverlaufstyp",
		"Longitudinal_Slope_Value": "Neigung",
		"LS_DEFAULT": "Gradient vom Startpunkt zum Endpunkt in der Punktwolke",
		"LS_CONSTANT": "Gradientenspezifikation",
		"LS_FLAT": "Wohnung",
		"LS_NONE": "Beliebige Einstellung ab Referenzpunkthöhe",
		"TRENCH_DEPTH": "Aushubtiefe",
		"REFERENCE_POINT_CLOUD_ASSET": "Referenzpunktwolkendaten",
		"REFERENCE_DESIGN_ASSET": "Referenzdesigndaten",
		"DEFAULT_ELEVATION": "Höhe des Startpunkts",
		"OBJECT_DATA": "Objektdaten",
		"SPECIFIED_ALTITUDE": "Höhenbezeichnung",
		"SET_SPECIFIED_ALTITUDE": "Bitte legen Sie die Höhe fest",
		"BTN_OBJECT": "Objekt hinzufügen",
		"SELECT_OBJECT": "Objekttyp auswählen",
		"PROJECTED_GROUND": "Auf den Boden projiziert",
		"REFERENCE_FLAT_GROUND": "Flache Referenzdaten",
		"LINEWORKS": "Linienwerke",
		"ROAD": "Straße",
		"FLATGROUND": "Flacher Boden",
		"TRENCH": "Graben",
		"Slope_Reference_Point": "Anhaltspunkt",
		"CREATE_LINEWORK": "Beliebige lineare Schöpfung",
		"CREATE_LINEWORK_FROM_CENTER_LINE": "Beliebige lineare Schöpfung",
		"LINEWORK_DATA": "lineare Daten",
		"ArbitraryLinename": "Linearer Name",
		"WidthofLineWork": "lineare Breite",
		"LineWorkparamater": "Linearer Sollwert",
		"ADD_LINEWORK_INFO": "Fügen Sie lineare Informationen hinzu",
		"EDIT_LINEWORK_INFO": "Linienarbeit bearbeiten",
		"SELECT_LINEWORKS_DATA": "Datenauswahl für Linienarbeiten",
		"REQUEST": "Anfrage",
		"SELECT_DESIGN_DATA": "Auswahl der Designdaten",
		"SELECT_SURVEY_DATA": "Vermessungsdatenauswahl",
		"STATION_INTERVAL": "Stationsintervall",
		"Linesectionview": "Lineare Schnittansicht",
		"GENERATE_CROSS_SECTION": "Querschnitt generieren",
		"EDIT_CROSS_SECTION": "Querschnitt bearbeiten",
		"ENABLE_VERTICAL_SLOPE_VALUE": "Spezifikation der vertikalen Neigung",
		"START_POINT": "Startpunkt",
		"END_POINT": "Endpunkt",
		"LINEWORKS_LOADING_FAILED": "{name} Das Laden ist fehlgeschlagen",
		"LINEWORKS_CREATION_FAILED": "{name} Die Erstellung ist fehlgeschlagen",
		"LINEWORKS_DELETE_FAILED": "{name} Löschen fehlgeschlagen",
		"LINEWORKS_EXPORT_FAILED": "{name} Ausgabe fehlgeschlagen",
		"LINEWORKS_CROSS_SECTION_DOWNLOAD_FAILED": "Querschnitt von {name} konnte nicht heruntergeladen werden",
		"LINEWORKS_UPDATE_FAILED": "Die Aktualisierung der Linie ist fehlgeschlagen",
		"GEOTIFF_EXPORT_FAILED": "GeoTIFF-Export fehlgeschlagen.",
		"EXPORT_CROSS_SECTION_DXF": "Querschnitt exportieren",
		"EXPORT_CENTERLINE": "Mittellinie exportieren",
		"CENTER_LINE": "Mittellinie",
		"CENTER_LINE_CREATION_FAILED": "Die Mittellinie für {name} konnte nicht erstellt werden.",
		"CROSS_SECTION_INVALID_VALUES": "Querschnitt kann aufgrund ungültiger Werte nicht generiert werden",
		"ADD_LINE_WORKS": "Zeile hinzufügen",
		"OUTPUT_DESTINATION": "Ziel",
		"OUTPUT_FORMAT": "Format",
		"SAVE_TO_LOCAL": "Auf diesem PC speichern",
		"DXF": "DXF",
		"SELECT_CREATION_TYPE": "Wählen Sie den Erstellungstyp aus",
		"UPLOAD_LINE_WORKS": "Upload-Leitung funktioniert",
		"LINE_PROFILE_VIEW": "Linienprofil-Ansicht",
		"LICENSE_MIGRATION_MESSAGE": "Die Registrierung eines Lizenzbenutzers ist jetzt obligatorisch. <br> Sie müssen den Lizenzen Ihres Unternehmens Benutzerrechte zuweisen. Das Konto, bei dem Sie derzeit angemeldet sind, ist nicht registriert. br> Sie können sich über den untenstehenden Link als Lizenzbenutzer registrieren. <br> [<a href={url}>Zur Registrierung der Lizenznutzung gehen</a>]<br> Nur Personen mit Super Admin- oder Admin-Rechten (Organisationsadministrator) können den Registrierungsvorgang durchführen. Für alle anderen wenden Sie sich bitte an den Administrator Ihrer Organisation, um sich zu registrieren. )",
		"NOTICE": "Beachten",
		"LICENSE_CHECK": "Lizenzprüfung",
		"NO_PERMISSION_TO_VIEW_SITE": "Sie haben keine Berechtigung, die Website anzuzeigen",
		"FAILED_TO_FETCH_SITE_INFO": "Website-Informationen konnten nicht abgerufen werden",
		"NOT_EXIST_SITE_INFO": "",
		"ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP": "",
		"DROP_FILES_HERE": "Dateien hier ablegen",
		"LOCALIZATION_FILE_UPLOAD_LABEL": "Lokalisierungsdatei ({0})",
		"LOCALIZATION_FILE_UPLOAD_CAPTION": "Legen Sie den Standort und das Standortkoordinatensystem fest",
		"INVALID_EXTENSION_ERROR": "Die ausgewählte Datei hat eine falsche Erweiterung",
		"FAILED_TO_CONVERT_LOCALIZATION_DATA": "Konvertierung in Lokalisierungsdaten fehlgeschlagen",
		"UPLOAD_LOCALIZATION_FILE": "Datei hochladen",
		"LINEWORKS_PROJECTION_SUCCESS": "Die Projektion der Bodenoberfläche von {name} ist abgeschlossen",
		"LINEWORKS_PROJECTION_FAILED": "Die Projektion der Bodenoberfläche von {name} ist fehlgeschlagen",
		"LOCK_OR_UNLOCK_ERROR": "Die Sperre konnte nicht erworben oder freigegeben werden",
		"LOST_OBJECT_EDIT_WEBSOCKET_CONNECTION": "Die Verbindung mit dem Server ist verloren gegangen. Wenn Sie ein Objekt bearbeiten möchten, laden Sie bitte die Seite neu",
		"CONNECTION_LOST_LOCK_ERROR": "Die Verbindung zum Server wurde unterbrochen. Bitte laden Sie die Seite neu, um die Verbindung wiederherzustellen",
		"INVALID_SIMA_UPLOAD_FAILED": "Upload fehlgeschlagen. {name} ist eine nicht unterstützte Datei im SIMA-Format.",
		"DRAWING_2D_IMAGE": "2D-Bild zeichnen",
		"SELECT_SITE_COORDINATE_SYSTEM_NOTE": "Es gibt einen Unterschied im registrierten Koordinatensystem. Bitte wählen Sie das zu verwendende Koordinatensystem aus.",
		"SELECT_SITE_COORDINATE_SYSTEM_ALERT": "Wenn Sie das Koordinatensystem von Design3D ändern, können die von Ihnen erstellten Objekte möglicherweise nicht mehr verwendet werden.",
		"COORDINATE_SYSTEM_FROM": "Koordinatensystem({name})",
		"DESIGN_3D": "Design3D",
		"OTHER_APPLICATION": "andere Anwendung",
		"LABEL_ROTATION": "Drehung",
		"LABEL_ORIGIN_EASTING": "Ursprung Easting",
		"LABEL_ORIGIN_NORTHING": "Ursprung Northing",
		"LABEL_ORIGIN_LATITUDE": "Ursprung Breite",
		"LABEL_ORIGIN_LONGITUDE": "Ursprung Länge",
		"LABEL_SCALE_FACTOR": "Skalierungsfaktor",
		"LABEL_VERTICAL_OFFSET": "Vertikale Verschiebung",
		"LABEL_INCLINE_X": "Neigung_x",
		"LABEL_INCLINE_Y": "Neigung_y",
		"LABEL_TO_METERS": "In Meter umwandeln",
		"LABEL_COORDINATE_SYSTEM": "Koordinatensystem",
		"LABEL_VERTICAL_SHIFT": "Vertikales Referenzsystem",
		"OPEN_THE_SITE": "Website öffnen",
		"CHANGE_SITE_COORDINATE_SYSTEM_WARNING_MESSAGE": "Die relativen Positionen der konfigurierten Objekte und des Geländes können verschoben werden, was zu Anzeige- und Betriebsproblemen führt.",
		"PROCEED": "Fortfahren",
		"MESSAGE_ERROR_GET_COORDINATE_SYSTEM": "Fehler beim Abrufen der Koordinatensysteminformationen.",
		"MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM": "Fehler beim Festlegen des Koordinatensystems.",
		"MESSAGE_NOT_FOUND_LOCALIZATION_FILE": "Lokalisierungsdatei nicht gefunden. Bitte erneut hochladen.",
		"MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE": "Die Website ist nicht im Dashboard registriert.",
		"MESSAGE_ERROR_DEFAULT": "Ein unerwarteter Fehler ist aufgetreten.",
		"CLICK_TO_SELECT_SOURCE_POINT": "Klicken Sie auf die Karte, um den Startpunkt für Position {number} auszuwählen",
		"CLICK_TO_SELECT_DESTINATION_POINT": "Klicken Sie auf die Karte, um den Endpunkt für Position {number} auszuwählen",
		"PLEASE_ENTER_VALID_INPUT": "Bitte geben Sie eine gültige Eingabe ein",
		"SOURCE_POINT": "Quelle",
		"DESTINATION_POINT": "Ziel",
		"NO_DATA_AVAILABLE": "Keine verfügbaren Daten",
		"TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE": "Externe Seite öffnen",
		"LABEL_DASHBOARD": "",
		"LABEL_SIMULATION": "",
		"CLICK_ON_THE_MAP_TO_SET_IMAGE": "",
		"REFERENCE_TOPOLOGY": "Referenztopologie",
		"ELEVATION": "Elevation",
		"SAVE": "Speichern",
		"CREATE_REFERENCE_TOPOLOGY": "Referenztopologie erstellen",
		"FILE_UPLOAD": "Datei hochladen",
		"IMPORT_FROM_GROUPWARE": "Importieren aus Groupware",
		"UPLOAD_DATA_TYPE_LABEL": "Type de données à télécharger",
		"FILE_TYPE_NOT_SUPPORTED": "Nicht unterstützter Dateityp",
		"NEXT": "",
		"FILE_AUTHOR": "",
		"LAST_MODIFIED": "",
		"LAST_MODIFIED_BY": "",
		"FILE_SIZE": "",
		"HOME": "",
		"SEARCH_FILE_NAME": "",
		"AND_N_MORE": "",
		"LIST_DISPLAYING": "",
		"SHOW_MORE": "",
		"NO_MORE_PROJECTS": "",
		"FAILED_TO_CREATE_REFERENCE_TOPOLOGY": "Referenztopologie konnte nicht erstellt werden",
		"TWO_POINT_ALIGNMENT": "2-Punkt-Ausrichtung",
		"REGISTER_TO_GROUPWARE": "Im Groupware Smart Construction registrieren",
		"ReferenceTopology": "Referenztopologie",
		"PointCloud": "Vermessungsdaten",
		"DesignData": "Designdaten",
		"SELECT_ASSOCIATED_TERRAIN": "Bitte wählen Sie das zugehörige Gelände",
		"SELECT_RUBBING_DESTINATION": "Bitte wählen Sie die Reibungsziel",
		"SIMPLE_STRUCTURE_DATA": "Liste einfacher Strukturen",
		"CUSTOM_STRUCTURE_DETAILS": "Details der benutzerdefinierten Struktur",
		"SHAPE_TYPE": "Formtyp",
		"SHAPE_CUBE": "Würfel",
		"SHAPE_SPHERE": "Kugel",
		"SHAPE_CYLINDER": "Zylinder",
		"TRANSPARENCY": "Transparenz",
		"DIAMETER": "Durchmesser",
		"DIMENSION": "Abmessung",
		"DIMENSIONS": "Abmessungen",
		"RADIUS": "Radius",
		"ANCHOR_POINT": "Ankerpunkt",
		"CENTER_POSITION": "Position des Mittelpunkts",
		"TRANSFORM": "Transformation",
		"LOCAL_CENTER": "Lokaler Mittelpunkt",
		"ROTATION": "Rotation",
		"SCALE": "Skalierung",
		"RESET_TRANSFORM": "Transformation zurücksetzen",
		"CONFIRM_DELETE_SIMPLE_STRUCTURE_MESSAGE": "Möchten Sie diese einfache Struktur löschen?",
		"DELETE_SIMPLE_STRUCTURE": "Einfache Struktur löschen",
		"ADD_SIMPLE_STRUCTURE": "Fügen Sie eine einfache Struktur hinzu",
		"SIMPLE_STRUCTURE": "Einfache Struktur",
		"SELECT_STRUCTURE_TYPE": "Strukturtyp auswählen",
		"BASIC_INFO": "Grundinformationen",
		"PARAMETERS": "Parameter",
		"PLACEMENT_POSITION": "Platzierungsposition",
		"POSITION": "Position",
		"STRUCTURE_TYPE_PIPE": "Rohr",
		"STRUCTURE_TYPE_BOX_CULVERT": "Kastendurchlass",
		"STRUCTURE_TYPE_RETAINING_WALL": "Stützmauer",
		"STRUCTURE_TYPE_MANHOLE": "Einstiegsschacht",
		"STRUCTURE_TYPE_MANUAL": "Benutzerdefiniert",
		"ADD_PIPE": "Rohr hinzufügen",
		"ADD_BOX_CULVERT": "Kastendurchlass hinzufügen",
		"ADD_RETAINING_WALL": "Stützmauer hinzufügen",
		"ADD_MANHOLE": "Einstiegsschacht hinzufügen",
		"ADD_MANUAL": "Benutzerdefinierte Struktur hinzufügen",
		"ADD_CUBE": "Würfel hinzufügen",
		"ADD_SPHERE": "Kugel hinzufügen",
		"ADD_CYLINDER": "Zylinder hinzufügen",
		"PIPE_DETAILS": "Rohrdetails",
		"BOX_CULVERT_DETAILS": "Kastendurchlass-Details",
		"RETAINING_WALL_DETAILS": "Stützmauer-Details",
		"MANHOLE_DETAILS": "Einstiegsschacht-Details",
		"PIPE_DIAMETER": "Durchmesser",
		"PIPE_BASIS_POINT_1": "Basispunkt 1",
		"PIPE_BASIS_POINT_2": "Basispunkt 2",
		"PIPE_LENGTH": "Länge",
		"WALL_BASIS_POINT_1": "Basispunkt 1",
		"WALL_BASIS_POINT_2": "Basispunkt 2",
		"CULVERT_WIDTH": "Breite",
		"CULVERT_HEIGHT": "Höhe",
		"CULVERT_LENGTH": "Länge",
		"WALL_WIDTH": "Breite",
		"WALL_HEIGHT": "Höhe",
		"WALL_LENGTH": "Länge",
		"WALL_THICKNESS": "Dicke",
		"MANHOLE_SIZE_CUSTOM": "Benutzerdefiniert",
		"MANHOLE_DIAMETER": "Durchmesser",
		"MANHOLE_DEPTH": "Tiefe",
		"MANUAL_LENGTH": "Länge",
		"MANUAL_WIDTH": "Breite",
		"MANUAL_HEIGHT": "Höhe",
		"GRADIENT": "Neigung",
		"GRADIENT_PERCENT": "Neigung (%)",
		"GRADIENT_RATIO": "Neigung (1:n)",
		"BASIS_POINT": "Basispunkt",
		"BASIS_POINT_1": "Basispunkt 1",
		"BASIS_POINT_2": "Basispunkt 2",
		"TWO_POINT_PICK_STEP1": "Klicken Sie auf {point} (Rechtsklick zum Abbrechen)",
		"TWO_POINT_PICK_STEP2": "Klicken Sie auf {point} (Rechtsklick zum Rückgängigmachen)",
		"COORDINATE_ACQUISITION_FAILED": "Koordinaten konnten nicht abgerufen werden",
		"AZIMUTH": "Azimut",
		"Height": "Höhe",
		"Length": "Länge",
		"Point": "Punkt",
		"Control Point": "Kontrollpunkt",
		"Not Available": "Nicht verfügbar",
		"X": "X",
		"Y": "Y",
		"Z": "Z",
		"Length On Datum": "Ebene",
		"name": "Name",
		"Enable": "Aktivieren",
		"Disable": "Deaktivieren",
		"UpdateAlignment": "Ausrichtung aktualisieren",
		"UpdateAlignmentDescription": "Diese Ausrichtung enthält alte Kurvendaten. Wie möchten Sie die Ausrichtung aktualisieren?",
		"VISIBILITY": "Anzeige / Ausblendung",
		"ALIGNMENT": "Ausrichtung",
		"IP_LINE": "IP-Linie",
		"SURFACE": "Oberfläche",
		"EMBANKMENT": "Damm",
		"FILL_EMBANKMENT": "Damm",
		"CUT_EMBANKMENT": "Damm"
	},
	"cs": {
		"NOT_STARTED": "Měřicí data",
		"OPACITY": "Průhlednost",
		"DESIGN": "Návrhy",
		"GET_DATA": "Získávání dat",
		"Addtemporaryroad": "Přidat dočasnou cestu",
		"Addtemporarytrench": "kopání postele",
		"Addfoundationexcavation": "Výkop základů",
		"Roadparameter": "Parametr cesty",
		"Trenchparameter": "Kopání/broušení podlah",
		"Cutsetting": "Nastavení řezu",
		"Fillsetting": "Nastavení zahrnutí",
		"Soilvolume": "Objem půdy",
		"SurfaceArea": "plocha povrchu",
		"Longitudinalsectionview": "Zobrazení podélného řezu",
		"CROSS_SECTION": "průřez",
		"SWAP_XY": "Prohodit XY",
		"Crosssectionview": "Zobrazení příčného řezu",
		"Measurementview": "Libovolné zobrazení řezu",
		"CREATE_DISTANCE_POINTS": "Vytvořit vzdálenost mezi dvěma body",
		"Accountmanagement": "Správa účtu",
		"Refresh": "Obnovit",
		"EXPORT_AS": "Exportovat jako…",
		"FLY_TO_ANNOTATION": "Jdi na anotace",
		"EDIT": "Upravit",
		"FINISH_EDITING": "Úprava dokončena",
		"CANNOT_FINISH_EDITING_INVALID_VALUES": "Nelze dokončit úpravy kvůli neplatným hodnotám",
		"CANNOT_SHOW_OBJECT_INVALID_VALUES": "Nelze zobrazit objekt kvůli neplatným hodnotám",
		"REMOVE": "Odstranit",
		"DUPLICATE": "",
		"DUPLICATION_SUCCESSFUL": "",
		"DUPLICATION_FAILED": "",
		"DELETION_FAILED": "",
		"LandXML": "LandXML",
		"GEOTIFF": "Geotiff",
		"ExportRoad": "Export【{name}】.",
		"ExportObject": "Export【{name}】.",
		"SelectOutputFormat": "Vyberte formát exportu.",
		"Registertodashboard": "Zaregistrujte se do Smart Construction Dashboard",
		"OK": "OK",
		"CANCEL": "Zrušit",
		"BACK": "Zpět",
		"Lengthofroad": "Délka cesty",
		"Lengthoftrench": "Délka výkopu lože",
		"Widthofroad": "Šířka cesty",
		"Widthoftrench": "šířka výkopu postele",
		"Left": "Levá strana",
		"Right": "Pravá strana",
		"Elevationarea": "Oblast elevace",
		"Gradientarea": "Oblast svahu",
		"Setsuperelevation": "Nastavit super elevaci",
		"Crossslope": "Příčný svah",
		"Superelevation": "Super nadmořská výška",
		"Roadcrosssectiongradient": "Sklon příčného řežu cesty",
		"Down": "+ -",
		"Up": "+ -",
		"ASSOCIATED_POINT_CLOUD": "Skupina posuvných bodů",
		"ASSOCIATED_TERRAIN_TYPE": "Assoziiertes Geländetyp",
		"ASSOCIATED_DESIGN_DATA": "Assoziiertes Design-Daten",
		"ASSOCIATED_REFERENCE_TOPOLOGY": "Assoziiertes Referenz-Topologie",
		"Distance": "Vzdálenost",
		"SLOPE_COLOR": "Barva svahu",
		"ROAD_SURFACE_COLOR": "Barva vozovky",
		"COLOR_SETTINGS": "Nastavení barev",
		"CUT_SLOPE_COLOR": "Barva řezu svahu",
		"FILL_SLOPE_COLOR": "Barva násypu svahu",
		"TRENCH_SURFACE_COLOR": "Barva povrchu výkopu",
		"Slopeheight": "Výška svahu",
		"Slopegradient": "Sklon svahu",
		"LeftRightSettings": "Nastavení vlevo/vpravo",
		"BERM_SETTINGS": "Nastavení krajnice",
		"Thereisberm": "Přidat násypový val",
		"Bermwidth": "Šířka krajnice",
		"Bermgradient": "Sklon krajnice",
		"Leftrightsetting": "Nastavení zleva doprava",
		"Leftcutsetting": "Nastavení řezu vlevo",
		"Rightcutsetting": "Nastavení řezu vpravo",
		"Cut": "Řez",
		"FILL": "Násyp",
		"Roadname": "Název cesty",
		"Trenchname": "Název výkopu podlahy",
		"NAME": "Název",
		"ADD": "Přidat",
		"Apply": "Použít",
		"Linetype": "Typ linie",
		"Straightline": "Přímá linie",
		"Curvedline": "Zahnutá linie",
		"TangentAlignment": "vše urovnat",
		"SimpleCurveAlignment": "Udělejte vše zakřivené",
		"Control": "Ovládání",
		"Undo": "Vrátit zpět",
		"Redo": "Provést znovu",
		"Finishdrawing": "Dokončit výkres",
		"Deletedrawing": "Odstranit výkres",
		"CONTROL_POINTS": "Kontrolní body",
		"Remove": "Odstranit",
		"Extendroad": "Prodloužit cestu",
		"MAX_LENGTH_ERROR": "Překročení počtu číslic",
		"REQUIRED_ERROR": "Povinná pole",
		"Update": "Hodnota souřadnice",
		"UPDATE_DATA": "Aktualizace dat",
		"ADD_DATA_LAYER": "Přidat novou vrstvu",
		"NO_DATA": "Žádné data",
		"DATA_LAYERS": "Datové vrstvy",
		"PROJECT_SETTINGS": "Nastavení projektu",
		"DISTANCE_UNITS": "Vzdálenostní jednotky",
		"DISTANCE": "Vzdálenost",
		"AREA": "Oblast",
		"VOLUME": "Objem",
		"SLOPE": "Svah",
		"RATIO_WORD": "Poměr (:)",
		"METERS_SQUARED_UNIT": "m²",
		"SQUARE_METERS_WORD": "Čtvereční metry (m²)",
		"METERS_WORD": "Metr (m)",
		"SQUARE_FEET_WORD": "Čtvereční stopy (sq ft)",
		"FEET_WORD": "Stopa (ft)",
		"US_SURVEY_FEET_WORD": "US Survey Feet (ft)",
		"ACRES_WORD": "Akry (ac)",
		"HECTARES_WORD": "Hektar (ha)",
		"CUBIC_YARDS_WORD": "Kubický yard (cu yd)",
		"MEASUREMENT": "měření",
		"METERS_CUBED_UNIT": "m³",
		"METERS_CUBED_WORD": "Metr kubický (m³)",
		"SELECT_DATA_TYPE": "Vyberte typ dat",
		"UPLOAD": "Nahrát",
		"UPLOADING": "Nahrávání",
		"UPLOAD_ERROR": "Nahrávání selhalo",
		"Roadctrlptwarning": "Neplatný kontrolní bod pro silnici",
		"INVALID_CONTROL_POINT_TRENCH": "Neplatný kontrolní bod pro výkop podlahy",
		"NoPointCloudSelected": "PointCloud is not Selected",
		"ARBITRARY_LINE_CTRL_PT_WARNING": "Neplatný kontrolní bod pro čáru",
		"ASSET_NAME": "Jméno vrstvy",
		"ASSET_CAPTURE_DATE": "Datum pořízení dat",
		"SELECT_SINGLE_DATASET_FILE": "Vybrat soubor",
		"Projectlist": "Seznam projektu",
		"Project": "Projekt",
		"Addflatground": "Přidat plochou zem",
		"Flatgroundname": "Název ploché země",
		"Leftfillsetting": "Nastavení levé výplně",
		"Rightfillsetting": "Nastavení pravé výplně",
		"Alignwithterrain": "Zarovnat s terénem",
		"Alignwithstartpt.": "Zarovnat s počátečním bodem",
		"SELECT_FILES": "Vybrat soubory",
		"COORDINATE_SYSTEM": "Souřadnicový systém",
		"CQW0020900001": "Nastavení souřadnicového systému",
		"CQW0020900002": "Výběr souřadnicového systému",
		"CQW0020125006": "Použijte následující souřadnice",
		"CQW0020900004": "Souřadnicový systém",
		"CQW0020900005": "vertikální odkaz",
		"APPLY_LOCALIZATION_CHANGES": "použít lokalizaci",
		"CHANGE_COORDINATE_SYSTEM": "Změna souřadnic",
		"CEW0020800001": "Registrace souřadnicového systému se nezdařila",
		"CQW0020800001": "Potvrďte souřadnicový systém. Je to v pořádku?",
		"CIW0020800002": "*Pokud je stránka již registrována v Smart Construction Dashboard, musí být ve stejném souřadnicovém systému jako Smart Construction Dashboard.<br>*Pokud již byla na web nahrána data, prosím smažte vše a znovu nahrajte.",
		"LOCALIZATION_FILE": "Importovat ze Dashboard",
		"Confirm": "Potvrdit",
		"VERTICAL_DATUM": "Svislý vztažný bod",
		"POINT_CLOUD": "Měřicí data",
		"PROJECT": "Projekt",
		"JOBSITE_NAME": "Název stavby",
		"OPEN": "Otevřít",
		"ConfirmthecoordinatesystemAreyousure?": "Potvrďte souřadnicový systém Jste si jisti ?",
		"*Onceset,itcannotbechangedto": "* Jakmile je jednou nastaveno, nelze jej změnit na",
		"RoadadditionbyAI": "Přidání silnice pomocí AI",
		"RoadadditionTerrainByAI": "Aktualizovat hodnotu souřadnic",
		"Updatecoordinatevalue": "Průzkumný systém",
		"Surveysystem": "Přepnout režim tažení",
		"Switchdragmode": "Změna výšky (body)",
		"globe": "Zeměkoule",
		"show": "Ukázat",
		"hide": "Skrýt",
		"FLAT_GROUND_SURFACE_COLOR": "Barva horního povrchu",
		"failed": "neúspěšný",
		"successful": "úspěšný",
		"axis": "Osa",
		"list_search_title": "Vyhledat pracoviště",
		"sidebar_v_shift_title": "Vertikální posun",
		"number": "Číslo",
		"entity_upload_wait_msg": "Nahrání dat nějakou dobu trvá.\nPo chvíli čekání zkuste přístup znovu.",
		"RUBBLING_SETTINGS": "Nastavení interpolace",
		"InterpolationPitch": "Posuvné hřiště",
		"RUBBLING_DESTINATION": "místo určení",
		"LABEL_DESIGN_FILE": "Design Filename",
		"LABEL_TERRAIN_FILE": "Terrain Filename",
		"LABEL_CONSTRUCTION_PARAM": "Parametry sítě staveniště",
		"LABEL_IMPORTANCE_COEFFICIENT": "importance coefficient",
		"LINEAR_DATA": "Data segmentu čáry mezi dvěma body",
		"PRE_PROCESS": "Preprocess",
		"TEMPORARY_ROAD": "dočasná cesta",
		"TEMPORARY_ROAD_AI": "temporary_road_AI",
		"TERRAIN_INFO": "terrain info",
		"TERRAIN_X_VALUE_MIN": "terrain X value min",
		"TERRAIN_X_VALUE_MAX": "terrain X value max",
		"TERRAIN_Y_VALUE_MIN": "terrain Y value min",
		"TERRAIN_Y_VALUE_MAX": "terrain Y value max",
		"DESIGN_X_VALUE_MIN": "design X value min",
		"DESIGN_X_VALUE_MAX": "design X value max",
		"DESIGN_Y_VALUE_MIN": "design Y value min",
		"DESIGN_Y_VALUE_MAX": "design Y value max",
		"TERRAIN_Z_VALUE_MIN": "terrain height min",
		"TERRAIN_Z_VALUE_MAX": "terrain height max",
		"DESIGN_Z_VALUE_MIN": "design height min",
		"DESIGN_Z_VALUE_MAX": "design height max",
		"INPUT_X_VALUE_MIN": "X value min",
		"INPUT_X_VALUE_MAX": "X value max",
		"INPUT_Y_VALUE_MIN": "Y value min",
		"INPUT_Y_VALUE_MAX": "Y value max",
		"INPUT_XY_INTERVAL": "XY interval",
		"INPUT_Z_VALUE_MIN": "Z value min",
		"INPUT_Z_VALUE_MAX": "Z value max",
		"INPUT_Z_INTERVAL": "Z interval",
		"INPUT_ALLOW_MAX_GRADIENT": "allow max gradient",
		"INPUT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PROMPT_SEARCH_EXPANSION_RADIUS": "search expansion radius",
		"LABEL_PRIORITY_CUT": "Cut",
		"LABEL_PRIORITY_FILL": "Fill",
		"LABEL_PRIORITY_OVER_FILL": "Overfill",
		"LABEL_PRIORITY_OVER_CUT": "Overcut",
		"LABEL_PRIORITY_CF_DIFF": "Cut Fill Diff",
		"LABEL_PRIORITY_ROUTE": "Route Length",
		"MESSAGE_CONFIRM_START_END_POINT": "Create a temporary road at the two selected points.",
		"MESSAGE_CONFIRM_PREPROCESS": "Performs preprocessing of terrain information.",
		"MESSAGE_CONFIRM_SUFFIX": "Is it OK?",
		"MESSAGE_ERROR_PREPROCESS": "Failed to execute preprocessing.",
		"MESSAGE_ERROR_PREPROCESS_LOCKED": "Another user is performing pre-processing.",
		"MESSAGE_ERROR_CREATE_ROAD_AI": "Temporary road route search failed.",
		"MESSAGE_ERROR_INPUT_DATA_ERROR": "Input data error",
		"MESSAGE_ERROR_RANGE_START_END_POINT": "Include the coordinates of the starting and ending points.",
		"MESSAGE_ERROR_VALIDATE_REQUIRED": "Required.",
		"MESSAGE_ERROR_VALIDATE_COUNTER": "Max 20 characters.",
		"MESSAGE_ERROR_VALIDATE_NUMBER_LIMIT": "Please enter a value between 0.1 and 1.0.",
		"MESSAGE_ERROR_SELECT_START_END_POINT": "Specify the coordinate values including the design plane for the start and end points.",
		"SET_TERRAIN_DATA": "Set Terrain Data",
		"LABEL_COORDINATE_TEXT": "Coordinate",
		"TEXT_PROMPT_COORDINATE": "To specify a direct coordinate value,\n enter it directly in the box.",
		"LABEL_START_POINT": "Start Point",
		"LABEL_END_POINT": "End Point",
		"LABEL_X_COORDINATE": "X",
		"LABEL_Y_COORDINATE": "Y",
		"LABEL_Z_COORDINATE": "Z",
		"Startpoint": "startovní bod",
		"Endpoint": "poslední zastávka",
		"Sectionheight": "Výška sekce",
		"Designaltitude": "návrhová nadmořská výška",
		"COLOR": "barva",
		"FLAT_GROUND": "rovné pole",
		"FLATGROUND_PARAMETERS": "parametry rovného terénu",
		"SegmentSetting": "Nastavení sekce",
		"FLATGROUND_INTERVAL": "sklon svahu",
		"FLATGROUND_HEIGHT": "Maximální výška",
		"ERROR": "chyba",
		"REFRESH_OBJECT_LIST": "Obnovení seznamu objektů",
		"CANNOT_DELETE_ASSOCIATED_POINT_CLOUD": "Nelze odstranit, protože zadaný objekt existuje.",
		"EXCLUSIVE_EDIT": "Při úpravách",
		"EXCLUSIVE_NOTICE": "{lockUser} právě upravuje",
		"MULTIPLE_POINT_CLOUD_CANNOT_ADD": "Pokud zobrazujete více mračen bodů, nelze je přidat",
		"ESRI_115700": "115700:WGS_1984 (výška elipsoidu)",
		"SELECT_COORDINATE_SYSTEM": "Vyberte souřadnicový systém (lze vyhledávat)",
		"SELECT_VERTICAL_SHIFT": "Vybrat model geoidu (lze vyhledávat)",
		"MEASUREMENT_SYSTEM": "Systém průzkumu",
		"ROAD_SAVE_FAILURE": "Při vytváření cesty došlo k chybě. Prosím zkuste to znovu.",
		"FLAT_SAVE_FAILURE": "Vytvoření prostého pole se nezdařilo. Vytvořte jej prosím znovu.",
		"TRENCH_SAVE_FAILURE": "Vytvoření výkopu podlahy se nezdařilo. Vytvořte jej prosím znovu.",
		"LINEAR_SAVE_FAILURE": "Vytvoření lineární se nezdařilo. Vytvořte jej prosím znovu.",
		"With_Slope": "Se Slopem",
		"CREATE_LINEAR": "2-bodové měření",
		"Uniformdrag": "Změna výšky (rovina)",
		"RENAME": "Změna jména",
		"Create Arc": "soustředné kruhy",
		"EDITING_BY_OTHER_USER": "Editace jiným uživatelem.",
		"LOCK_FAILED": "Nepodařilo se získat zámek.",
		"UPDATE_FAILED_SELF_EDITING": "Nelze aktualizovat, protože existuje objekt, který se upravuje. \nPo dokončení úprav proveďte aktualizaci znovu.",
		"UPDATE_FAILED_OTHER_USER_EDITING": "Objekt nelze aktualizovat, protože jej upravuje jiný uživatel.",
		"FAILED_TO_GET_EDITING_USER": "Nepodařilo se načíst upravované informace o uživateli.",
		"UPDATE_FAILED_EDITING_OR_UPLOADING": "Nelze aktualizovat, protože se upravují nebo nahrávají data.",
		"Specified_Elevation": "Výchozí bod výkopu podlahy\nVýška dna",
		"Longitudinal_Slope_Type": "Typ přechodu",
		"Longitudinal_Slope_Value": "Sklon",
		"LS_DEFAULT": "Přechod z počátečního bodu do koncového bodu na mračnu bodů",
		"LS_CONSTANT": "Specifikace gradientu",
		"LS_FLAT": "byt",
		"LS_NONE": "Libovolné nastavení z výšky referenčního bodu",
		"TRENCH_DEPTH": "hloubka výkopu",
		"REFERENCE_POINT_CLOUD_ASSET": "Data mračna referenčních bodů",
		"REFERENCE_DESIGN_ASSET": "Referenční návrhová data",
		"DEFAULT_ELEVATION": "Nadmořská výška výchozího bodu",
		"OBJECT_DATA": "Data objektu",
		"SPECIFIED_ALTITUDE": "Nadmořská výška",
		"SET_SPECIFIED_ALTITUDE": "Nastavte nadmořskou výšku",
		"BTN_OBJECT": "Přidat objekt",
		"SELECT_OBJECT": "Vyberte typ objektu",
		"PROJECTED_GROUND": "Promítáno na zem",
		"REFERENCE_FLAT_GROUND": "Referenční plochá data",
		"LINEWORKS": "lineworks",
		"ROAD": "silnice",
		"FLATGROUND": "plochý",
		"TRENCH": "příkop",
		"Slope_Reference_Point": "referenční bod",
		"CREATE_LINEWORK": "Libovolná lineární tvorba",
		"CREATE_LINEWORK_FROM_CENTER_LINE": "Libovolná lineární tvorba",
		"LINEWORK_DATA": "lineární data",
		"ArbitraryLinename": "Lineární název",
		"WidthofLineWork": "lineární šířka",
		"LineWorkparamater": "Lineární požadovaná hodnota",
		"ADD_LINEWORK_INFO": "Přidejte lineární informace",
		"EDIT_LINEWORK_INFO": "Edit Line work",
		"SELECT_LINEWORKS_DATA": "Výběr dat linek",
		"REQUEST": "žádost",
		"SELECT_DESIGN_DATA": "Výběr dat návrhu",
		"SELECT_SURVEY_DATA": "Výběr průzkumných dat",
		"STATION_INTERVAL": "Interval stanice",
		"Linesectionview": "Lineární řez",
		"GENERATE_CROSS_SECTION": "Vygenerovat průřez",
		"EDIT_CROSS_SECTION": "Upravit průřez",
		"ENABLE_VERTICAL_SLOPE_VALUE": "Specifikace vertikálního sklonu",
		"START_POINT": "Startovní bod",
		"END_POINT": "Koncový bod",
		"LINEWORKS_LOADING_FAILED": "{name} načítání se nezdařilo",
		"LINEWORKS_CREATION_FAILED": "{name} vytvoření se nezdařilo",
		"LINEWORKS_DELETE_FAILED": "{name} smazání se nezdařilo",
		"LINEWORKS_EXPORT_FAILED": "{name} výstup se nezdařil",
		"LINEWORKS_CROSS_SECTION_DOWNLOAD_FAILED": "Stažení průřezu {name} se nezdařilo",
		"LINEWORKS_UPDATE_FAILED": "Aktualizace lineární se nezdařila",
		"GEOTIFF_EXPORT_FAILED": "Export GeoTIFF se nezdařil.",
		"EXPORT_CROSS_SECTION_DXF": "Exportovat průřez",
		"EXPORT_CENTERLINE": "Exportovat středovou čáru",
		"CENTER_LINE": "Středová čára",
		"CENTER_LINE_CREATION_FAILED": "Nepodařilo se vytvořit středovou čáru pro {name}.",
		"CROSS_SECTION_INVALID_VALUES": "Neplatné hodnoty v průřezu",
		"ADD_LINE_WORKS": "Přidat řádek",
		"OUTPUT_DESTINATION": "Cíl",
		"OUTPUT_FORMAT": "Formát",
		"SAVE_TO_LOCAL": "Uložit do tohoto počítače",
		"DXF": "DXF",
		"SELECT_CREATION_TYPE": "Vyberte typ vytvoření",
		"UPLOAD_LINE_WORKS": "Linka nahrávání funguje",
		"LINE_PROFILE_VIEW": "Zobrazení profilu čáry",
		"LICENSE_MIGRATION_MESSAGE": "Registrace uživatele licence je nyní povinná. <br> Musíte přiřadit uživatelská práva k licencím, které vlastní vaše společnost. Účet, ke kterému jste aktuálně přihlášeni, není registrován. br> Můžete se zaregistrovat jako uživatel licence z odkazu níže. <br> [<a href={url}>Přejít na registraci použití licence</a>]<br> Registraci mohou provádět pouze uživatelé s oprávněními Super Admin nebo Admin (administrátor organizace). U všech ostatních požádejte správce vaší organizace o registraci. )",
		"NOTICE": "Oznámení",
		"LICENSE_CHECK": "Kontrola licence",
		"NO_PERMISSION_TO_VIEW_SITE": "Nemáte oprávnění k prohlížení webu",
		"FAILED_TO_FETCH_SITE_INFO": "Nepodařilo se získat informace o webu",
		"NOT_EXIST_SITE_INFO": "",
		"ACQUIRING_POINT_CLOUD_DATA_FROM_OTHER_APP": "",
		"DROP_FILES_HERE": "Sem přetáhněte soubory",
		"LOCALIZATION_FILE_UPLOAD_LABEL": "Lokalizační soubor ({0})",
		"LOCALIZATION_FILE_UPLOAD_CAPTION": "Nastavte umístění lokality a souřadnicový systém lokality",
		"INVALID_EXTENSION_ERROR": "Vybraný soubor má nesprávnou příponu",
		"FAILED_TO_CONVERT_LOCALIZATION_DATA": "Převod na lokalizační data se nezdařil",
		"UPLOAD_LOCALIZATION_FILE": "Nahrát soubor",
		"LINEWORKS_PROJECTION_SUCCESS": "Projekce povrchu země {name} byla dokončena",
		"LINEWORKS_PROJECTION_FAILED": "Projekce povrchu země {name} se nezdařila",
		"LOCK_OR_UNLOCK_ERROR": "Nepodařilo se získat nebo uvolnit zámek",
		"LOST_OBJECT_EDIT_WEBSOCKET_CONNECTION": "Spojení se serverem bylo ztraceno. Pokud chcete upravit objekt, znovu načtěte stránku",
		"CONNECTION_LOST_LOCK_ERROR": "Spojení se serverem bylo přerušeno. Chcete-li se znovu připojit, načtěte stránku znovu",
		"INVALID_SIMA_UPLOAD_FAILED": "Odeslání se nezdařilo. {name} je nepodporovaný soubor ve formátu SIMA.",
		"DRAWING_2D_IMAGE": "Obrázek nakreslený ve 2D",
		"SELECT_SITE_COORDINATE_SYSTEM_NOTE": "Existuje rozdíl v registrovaném souřadnicovém systému. Vyberte prosím souřadnicový systém, který chcete používat.",
		"SELECT_SITE_COORDINATE_SYSTEM_ALERT": "Pokud změníte souřadnicový systém z aplikace Design3D, objekty, které jste vytvořili, nemusí být dále použitelné.",
		"COORDINATE_SYSTEM_FROM": "Souřadnicový systém({name})",
		"DESIGN_3D": "Design3D",
		"OTHER_APPLICATION": "jiná aplikace",
		"LABEL_ROTATION": "Rotace",
		"LABEL_ORIGIN_EASTING": "Původní Easting",
		"LABEL_ORIGIN_NORTHING": "Původní Northing",
		"LABEL_ORIGIN_LATITUDE": "Původní zeměpisná šířka",
		"LABEL_ORIGIN_LONGITUDE": "Původní zeměpisná délka",
		"LABEL_SCALE_FACTOR": "Faktor měřítka",
		"LABEL_VERTICAL_OFFSET": "Vertikální posun",
		"LABEL_INCLINE_X": "Sklon_x",
		"LABEL_INCLINE_Y": "Sklon_y",
		"LABEL_TO_METERS": "Převod na metry",
		"LABEL_COORDINATE_SYSTEM": "Souřadnicový systém",
		"LABEL_VERTICAL_SHIFT": "Vertikální referenční systém",
		"OPEN_THE_SITE": "Otevřít web",
		"CHANGE_SITE_COORDINATE_SYSTEM_WARNING_MESSAGE": "Relativní polohy nakonfigurovaných objektů a terénu se mohou posunout, což bude mít za následek problémy s zobrazením a provozem.",
		"PROCEED": "Pokračovat",
		"MESSAGE_ERROR_GET_COORDINATE_SYSTEM": "Chyba při získávání informací o souřadnicovém systému.",
		"MESSAGE_ERROR_FAILED_SET_COORDINATE_SYSTEM": "Chyba při nastavení souřadnicového systému.",
		"MESSAGE_NOT_FOUND_LOCALIZATION_FILE": "Lokalizační soubor nebyl nalezen. Nahrajte prosím znovu.",
		"MESSAGE_ERROR_NOT_FOUND_DASHBOARD_SITE": "Web není zaregistrován v Dashboardu.",
		"MESSAGE_ERROR_DEFAULT": "Došlo k neočekávané chybě.",
		"CLICK_TO_SELECT_SOURCE_POINT": "Klikněte na mapu a vyberte počáteční bod pro pozici {number}",
		"CLICK_TO_SELECT_DESTINATION_POINT": "Klikněte na mapu a vyberte koncový bod pro pozici {number}",
		"PLEASE_ENTER_VALID_INPUT": "Prosím zadejte platný vstup",
		"SOURCE_POINT": "Zdroj",
		"DESTINATION_POINT": "Cíl",
		"NO_DATA_AVAILABLE": "Nejsou k dispozici žádná data",
		"TOOLTIP_LABEL_OPEN_THE_EXTERNAL_PAGE": "Otevřít externí stránku",
		"LABEL_DASHBOARD": "",
		"LABEL_SIMULATION": "",
		"CLICK_ON_THE_MAP_TO_SET_IMAGE": "",
		"REFERENCE_TOPOLOGY": "Referenční topologie",
		"ELEVATION": "Výška",
		"SAVE": "Uložit",
		"CREATE_REFERENCE_TOPOLOGY": "Vytvořit referenční topologii",
		"FILE_UPLOAD": "Nahrát soubor",
		"IMPORT_FROM_GROUPWARE": "Importovat ze Groupware",
		"UPLOAD_DATA_TYPE_LABEL": "Vyberte typ dat pro nahrávání",
		"FILE_TYPE_NOT_SUPPORTED": "Nepodporovaný typ souboru",
		"NEXT": "",
		"FILE_AUTHOR": "",
		"LAST_MODIFIED": "",
		"LAST_MODIFIED_BY": "",
		"FILE_SIZE": "",
		"HOME": "",
		"SEARCH_FILE_NAME": "",
		"AND_N_MORE": "",
		"LIST_DISPLAYING": "",
		"SHOW_MORE": "",
		"NO_MORE_PROJECTS": "",
		"FAILED_TO_CREATE_REFERENCE_TOPOLOGY": "Nepodařilo se vytvořit referenční topologii",
		"TWO_POINT_ALIGNMENT": "2-bodové měření",
		"REGISTER_TO_GROUPWARE": "Zaregistrujte se v Groupware Smart Construction",
		"ReferenceTopology": "Referenční topologie",
		"PointCloud": "Měřicí data",
		"DesignData": "Návrhová data",
		"SELECT_ASSOCIATED_TERRAIN": "Vyberte základní terén",
		"SELECT_RUBBING_DESTINATION": "Vyberte cíl tření",
		"SIMPLE_STRUCTURE_DATA": "Seznam jednoduchých konstrukcí",
		"CUSTOM_STRUCTURE_DETAILS": "Detaily vlastní konstrukce",
		"SHAPE_TYPE": "Typ tvaru",
		"SHAPE_CUBE": "Krychle",
		"SHAPE_SPHERE": "Koule",
		"SHAPE_CYLINDER": "Válec",
		"TRANSPARENCY": "Průhlednost",
		"DIAMETER": "Průměr",
		"DIMENSION": "Rozměr",
		"DIMENSIONS": "Rozměry",
		"RADIUS": "Poloměr",
		"ANCHOR_POINT": "Kotvící bod",
		"CENTER_POSITION": "Pozice středu",
		"TRANSFORM": "Transformace",
		"LOCAL_CENTER": "Lokální střed",
		"ROTATION": "Rotace",
		"SCALE": "Měřítko",
		"RESET_TRANSFORM": "Obnovit transformaci",
		"CONFIRM_DELETE_SIMPLE_STRUCTURE_MESSAGE": "Opravdu chcete tuto jednoduchou konstrukci smazat?",
		"DELETE_SIMPLE_STRUCTURE": "Smazat jednoduchou konstrukci",
		"ADD_SIMPLE_STRUCTURE": "Přidejte jednoduchou konstrukci",
		"SIMPLE_STRUCTURE": "Jednoduchá konstrukce",
		"SELECT_STRUCTURE_TYPE": "Vybrat typ konstrukce",
		"BASIC_INFO": "Základní informace",
		"PARAMETERS": "Parametry",
		"PLACEMENT_POSITION": "Pozice umístění",
		"POSITION": "Pozice",
		"STRUCTURE_TYPE_PIPE": "Potrubí",
		"STRUCTURE_TYPE_BOX_CULVERT": "Krabicový propustek",
		"STRUCTURE_TYPE_RETAINING_WALL": "Opěrná zeď",
		"STRUCTURE_TYPE_MANHOLE": "Šachta",
		"STRUCTURE_TYPE_MANUAL": "Vlastní",
		"ADD_PIPE": "Přidat potrubí",
		"ADD_BOX_CULVERT": "Přidat krabicový propustek",
		"ADD_RETAINING_WALL": "Přidat opěrnou zeď",
		"ADD_MANHOLE": "Přidat šachtu",
		"ADD_MANUAL": "Přidat vlastní konstrukci",
		"ADD_CUBE": "Přidat krychle",
		"ADD_SPHERE": "Přidat kouli",
		"ADD_CYLINDER": "Přidat válec",
		"PIPE_DETAILS": "Detaily potrubí",
		"BOX_CULVERT_DETAILS": "Detaily krabicového propustku",
		"RETAINING_WALL_DETAILS": "Detaily opěrné zdi",
		"MANHOLE_DETAILS": "Detaily šachty",
		"PIPE_DIAMETER": "Průměr",
		"PIPE_BASIS_POINT_1": "Základní bod 1",
		"PIPE_BASIS_POINT_2": "Základní bod 2",
		"PIPE_LENGTH": "Délka",
		"WALL_BASIS_POINT_1": "Základní bod 1",
		"WALL_BASIS_POINT_2": "Základní bod 2",
		"CULVERT_WIDTH": "Šířka",
		"CULVERT_HEIGHT": "Výška",
		"CULVERT_LENGTH": "Délka",
		"WALL_WIDTH": "Šířka",
		"WALL_HEIGHT": "Výška",
		"WALL_LENGTH": "Délka",
		"WALL_THICKNESS": "Tloušťka",
		"MANHOLE_SIZE_CUSTOM": "Vlastní",
		"MANHOLE_DIAMETER": "Průměr",
		"MANHOLE_DEPTH": "Hloubka",
		"MANUAL_LENGTH": "Délka",
		"MANUAL_WIDTH": "Šířka",
		"MANUAL_HEIGHT": "Výška",
		"GRADIENT": "Sklon",
		"GRADIENT_PERCENT": "Sklon (%)",
		"GRADIENT_RATIO": "Sklon (1:n)",
		"BASIS_POINT": "Základní bod",
		"BASIS_POINT_1": "Základní bod 1",
		"BASIS_POINT_2": "Základní bod 2",
		"TWO_POINT_PICK_STEP1": "Klikněte na {point} (pravým tlačítkem pro zrušení)",
		"TWO_POINT_PICK_STEP2": "Klikněte na {point} (pravým tlačítkem zpět)",
		"COORDINATE_ACQUISITION_FAILED": "Nepodařilo se získat souřadnice",
		"AZIMUTH": "Azimut",
		"Height": "Výška",
		"Length": "Délka",
		"Point": "Bod",
		"Control Point": "Kontrolní bod",
		"Not Available": "Není dostupné",
		"X": "X",
		"Y": "Y",
		"Z": "Z",
		"Length On Datum": "Vzdálenost na úrovni",
		"name": "Název",
		"Enable": "Umožnit",
		"Disable": "Zakázat",
		"UpdateAlignment": "Aktualizovat vyrovnání",
		"UpdateAlignmentDescription": "Toto vyrovnání obsahuje stará data křivky. Jak chcete vyrovnání aktualizovat?"
	}
}
